var items = {
  "block.minecraft.acacia_button": "Akasiahouten knop",
  "block.minecraft.acacia_door": "Akasiahouten doar",
  "block.minecraft.acacia_fence": "Akasiahouten stek",
  "block.minecraft.acacia_fence_gate": "Akasiahouten stekpoartsje",
  "block.minecraft.acacia_hanging_sign": "Akasiahouten úthingboerd",
  "block.minecraft.acacia_leaves": "Akasiablêden",
  "block.minecraft.acacia_log": "Akasiastam",
  "block.minecraft.acacia_planks": "Akasiahouten planken",
  "block.minecraft.acacia_pressure_plate": "Akasiahouten drukplaat",
  "block.minecraft.acacia_sapling": "Akasiakymplant",
  "block.minecraft.acacia_shelf": "Acacia Shelf",
  "block.minecraft.acacia_sign": "Akasiahouten boerd",
  "block.minecraft.acacia_slab": "Akasiahouten plaat",
  "block.minecraft.acacia_stairs": "Akasiahouten trep",
  "block.minecraft.acacia_trapdoor": "Akasiahouten fallûk",
  "block.minecraft.acacia_wall_hanging_sign": "Akasiahouten úthingboerd",
  "block.minecraft.acacia_wall_sign": "Akasiahouten muorreboerd",
  "block.minecraft.acacia_wood": "Akasiahout",
  "block.minecraft.activator_rail": "Aktivaasjespoar",
  "block.minecraft.air": "Lucht",
  "block.minecraft.allium": "Wylde sipel",
  "block.minecraft.amethyst_block": "Ametistblok",
  "block.minecraft.amethyst_cluster": "Ametistencluster",
  "block.minecraft.ancient_debris": "Ald pún",
  "block.minecraft.andesite": "Andesyt",
  "block.minecraft.andesite_slab": "Andesiten plaat",
  "block.minecraft.andesite_stairs": "Andesiten trep",
  "block.minecraft.andesite_wall": "Andesytmuorre",
  "block.minecraft.anvil": "Ambyld",
  "block.minecraft.attached_melon_stem": "Fêste meloenstam",
  "block.minecraft.attached_pumpkin_stem": "Fêste pompoenstam",
  "block.minecraft.azalea": "Asalea",
  "block.minecraft.azalea_leaves": "Asaleablêden",
  "block.minecraft.azure_bluet": "Porselynstjerke",
  "block.minecraft.bamboo": "Bamboe",
  "block.minecraft.bamboo_block": "Bamboeblok",
  "block.minecraft.bamboo_button": "Bamboeknop",
  "block.minecraft.bamboo_door": "Bamboedoar",
  "block.minecraft.bamboo_fence": "Bamboestek",
  "block.minecraft.bamboo_fence_gate": "Bamboepoarte",
  "block.minecraft.bamboo_hanging_sign": "Bamboe-úthingboerd",
  "block.minecraft.bamboo_mosaic": "Bamboemozaïek",
  "block.minecraft.bamboo_mosaic_slab": "Bamboemozaïekplaat",
  "block.minecraft.bamboo_mosaic_stairs": "Bamboemozaïektrep",
  "block.minecraft.bamboo_planks": "Bamboeplanken",
  "block.minecraft.bamboo_pressure_plate": "Bamboedrukplaat",
  "block.minecraft.bamboo_sapling": "Bamboesprút",
  "block.minecraft.bamboo_shelf": "Bamboo Shelf",
  "block.minecraft.bamboo_sign": "Bamboeboerd",
  "block.minecraft.bamboo_slab": "Bamboeplaat",
  "block.minecraft.bamboo_stairs": "Bamboetrep",
  "block.minecraft.bamboo_trapdoor": "Bamboefallûk",
  "block.minecraft.bamboo_wall_hanging_sign": "Bamboe-úthingboerd",
  "block.minecraft.bamboo_wall_sign": "Bamboeboerd oan muorre",
  "block.minecraft.banner.base.black": "Folslein swart fjild",
  "block.minecraft.banner.base.blue": "Folslein blau fjild",
  "block.minecraft.banner.base.brown": "Folslein brún fjild",
  "block.minecraft.banner.base.cyan": "Folslein turkoaisk fjild",
  "block.minecraft.banner.base.gray": "Folslein griis fjild",
  "block.minecraft.banner.base.green": "Folslein grien fjild",
  "block.minecraft.banner.base.light_blue": "Folslein ljochtblau fjild",
  "block.minecraft.banner.base.light_gray": "Folslein ljochtgriis fjild",
  "block.minecraft.banner.base.lime": "Folslein ljochtgrien fjild",
  "block.minecraft.banner.base.magenta": "Folslein maginta fjild",
  "block.minecraft.banner.base.orange": "Folslein oranje fjild",
  "block.minecraft.banner.base.pink": "Folslein rôze fjild",
  "block.minecraft.banner.base.purple": "Folslein pears fjild",
  "block.minecraft.banner.base.red": "Folslein read fjild",
  "block.minecraft.banner.base.white": "Folslein wyt fjild",
  "block.minecraft.banner.base.yellow": "Folslein giel fjild",
  "block.minecraft.banner.border.black": "Swarte seam",
  "block.minecraft.banner.border.blue": "Blauwe seam",
  "block.minecraft.banner.border.brown": "Brune seam",
  "block.minecraft.banner.border.cyan": "Syane seam",
  "block.minecraft.banner.border.gray": "Grize seam",
  "block.minecraft.banner.border.green": "Griene seam",
  "block.minecraft.banner.border.light_blue": "Ljochtblauwe seam",
  "block.minecraft.banner.border.light_gray": "Ljochtgrize seam",
  "block.minecraft.banner.border.lime": "Ljochtgriene seam",
  "block.minecraft.banner.border.magenta": "Maginta seam",
  "block.minecraft.banner.border.orange": "Oranje seam",
  "block.minecraft.banner.border.pink": "Rôze seam",
  "block.minecraft.banner.border.purple": "Pearze seam",
  "block.minecraft.banner.border.red": "Reade seam",
  "block.minecraft.banner.border.white": "Wite seam",
  "block.minecraft.banner.border.yellow": "Giele seam",
  "block.minecraft.banner.bricks.black": "Swart mitsele fjild",
  "block.minecraft.banner.bricks.blue": "Blau mitsele fjild",
  "block.minecraft.banner.bricks.brown": "Brún mitsele fjild",
  "block.minecraft.banner.bricks.cyan": "Syane mitsele fjild",
  "block.minecraft.banner.bricks.gray": "Griis mitsele",
  "block.minecraft.banner.bricks.green": "Grien mitsele fjild",
  "block.minecraft.banner.bricks.light_blue": "Ljochtblau mitsele fjild",
  "block.minecraft.banner.bricks.light_gray": "Ljochtgriis mitsele fjild",
  "block.minecraft.banner.bricks.lime": "Ljochtgrien mitsele fjild",
  "block.minecraft.banner.bricks.magenta": "Maginta mitsele fjild",
  "block.minecraft.banner.bricks.orange": "Oranje mitsele fjild",
  "block.minecraft.banner.bricks.pink": "Rôze mitsele fjild",
  "block.minecraft.banner.bricks.purple": "Pears mitsele fjild",
  "block.minecraft.banner.bricks.red": "Read mitsele fjild",
  "block.minecraft.banner.bricks.white": "Wyt mitsele fjild",
  "block.minecraft.banner.bricks.yellow": "Giel mitsele fjild",
  "block.minecraft.banner.circle.black": "Swarte rozet",
  "block.minecraft.banner.circle.blue": "Blauwe rozet",
  "block.minecraft.banner.circle.brown": "Brune rozet",
  "block.minecraft.banner.circle.cyan": "Syane rozet",
  "block.minecraft.banner.circle.gray": "Grize rozet",
  "block.minecraft.banner.circle.green": "Griene rozet",
  "block.minecraft.banner.circle.light_blue": "Ljochtblauwe rozet",
  "block.minecraft.banner.circle.light_gray": "Ljochtgrize rozet",
  "block.minecraft.banner.circle.lime": "Ljochtgriene rozet",
  "block.minecraft.banner.circle.magenta": "Maginta rozet",
  "block.minecraft.banner.circle.orange": "Oranje rozet",
  "block.minecraft.banner.circle.pink": "Rôze rozet",
  "block.minecraft.banner.circle.purple": "Pearze rozet",
  "block.minecraft.banner.circle.red": "Reade rozet",
  "block.minecraft.banner.circle.white": "Wite rozet",
  "block.minecraft.banner.circle.yellow": "Giele rozet",
  "block.minecraft.banner.creeper.black": "Swart Creeperwapen",
  "block.minecraft.banner.creeper.blue": "Blau Creeperwapen",
  "block.minecraft.banner.creeper.brown": "Brún Creeperwapen",
  "block.minecraft.banner.creeper.cyan": "Syane Creeperwapen",
  "block.minecraft.banner.creeper.gray": "Grize Creeperwapen",
  "block.minecraft.banner.creeper.green": "Grien Creeperwapen",
  "block.minecraft.banner.creeper.light_blue": "Ljochtblau Creeperwapen",
  "block.minecraft.banner.creeper.light_gray": "Ljochtgrize Creeperwapen",
  "block.minecraft.banner.creeper.lime": "Ljochtgriene Creeperwapen",
  "block.minecraft.banner.creeper.magenta": "Maginta Creeperwapen",
  "block.minecraft.banner.creeper.orange": "Oranje Creeperwapen",
  "block.minecraft.banner.creeper.pink": "Rôze Creeperwapen",
  "block.minecraft.banner.creeper.purple": "Pearze Creeperwapen",
  "block.minecraft.banner.creeper.red": "Read Creeperwapen",
  "block.minecraft.banner.creeper.white": "Wite Creeperwapen",
  "block.minecraft.banner.creeper.yellow": "Giele Creeperwapen",
  "block.minecraft.banner.cross.black": "Swart andreäskrús",
  "block.minecraft.banner.cross.blue": "Blau andreäskrús",
  "block.minecraft.banner.cross.brown": "Brún andreäskrús",
  "block.minecraft.banner.cross.cyan": "Syane andreäskrús",
  "block.minecraft.banner.cross.gray": "Griis andreäskrús",
  "block.minecraft.banner.cross.green": "Grien andreäskrús",
  "block.minecraft.banner.cross.light_blue": "Ljochtblau andreäskrús",
  "block.minecraft.banner.cross.light_gray": "Ljochtgriis andreäskrús",
  "block.minecraft.banner.cross.lime": "Ljochtgrien andreäskrús",
  "block.minecraft.banner.cross.magenta": "Maginta andreäskrús",
  "block.minecraft.banner.cross.orange": "Oranje andreäskrús",
  "block.minecraft.banner.cross.pink": "Rôze andreäskrús",
  "block.minecraft.banner.cross.purple": "Pears andreäskrús",
  "block.minecraft.banner.cross.red": "Read andreäskrús",
  "block.minecraft.banner.cross.white": "Wyt andreäskrús",
  "block.minecraft.banner.cross.yellow": "Giel andreäskrús",
  "block.minecraft.banner.curly_border.black": "Swarte ynkepe seam",
  "block.minecraft.banner.curly_border.blue": "Blauwe ynkepe seam",
  "block.minecraft.banner.curly_border.brown": "Brune ynkepe seam",
  "block.minecraft.banner.curly_border.cyan": "Syane ynkepe seam",
  "block.minecraft.banner.curly_border.gray": "Grize ynkepe seam",
  "block.minecraft.banner.curly_border.green": "Griene ynkepe seam",
  "block.minecraft.banner.curly_border.light_blue": "Ljochtblauwe ynkepe seam",
  "block.minecraft.banner.curly_border.light_gray": "Ljochtgrize ynkepe seam",
  "block.minecraft.banner.curly_border.lime": "Ljochtgriene ynkepe seam",
  "block.minecraft.banner.curly_border.magenta": "Maginta ynkepe seam",
  "block.minecraft.banner.curly_border.orange": "Oranje ynkepe seam",
  "block.minecraft.banner.curly_border.pink": "Rôze ynkepe seam",
  "block.minecraft.banner.curly_border.purple": "Pearze ynkepe seam",
  "block.minecraft.banner.curly_border.red": "Reade ynkepe seam",
  "block.minecraft.banner.curly_border.white": "Wite ynkepe seam",
  "block.minecraft.banner.curly_border.yellow": "Giele ynkepe seam",
  "block.minecraft.banner.diagonal_left.black": "Swart links ôfskeane",
  "block.minecraft.banner.diagonal_left.blue": "Blau links ôfskeane",
  "block.minecraft.banner.diagonal_left.brown": "Brún links ôfskeane",
  "block.minecraft.banner.diagonal_left.cyan": "Syaan links ôfskeane",
  "block.minecraft.banner.diagonal_left.gray": "Griis links ôfskeane",
  "block.minecraft.banner.diagonal_left.green": "Grien links ôfskeane",
  "block.minecraft.banner.diagonal_left.light_blue": "Ljochtblau links ôfskeane",
  "block.minecraft.banner.diagonal_left.light_gray": "Ljochtgriis links ôfskeane",
  "block.minecraft.banner.diagonal_left.lime": "Ljochtgrien links ôfskeane",
  "block.minecraft.banner.diagonal_left.magenta": "Maginta links ôfskeane",
  "block.minecraft.banner.diagonal_left.orange": "Oranje links ôfskeane",
  "block.minecraft.banner.diagonal_left.pink": "Rôze links ôfskeane",
  "block.minecraft.banner.diagonal_left.purple": "Pears links ôfskeane",
  "block.minecraft.banner.diagonal_left.red": "Read links ôfskeane",
  "block.minecraft.banner.diagonal_left.white": "Wyt links ôfskeane",
  "block.minecraft.banner.diagonal_left.yellow": "Giel links ôfskeane",
  "block.minecraft.banner.diagonal_right.black": "Swart rjochts ôfskeane",
  "block.minecraft.banner.diagonal_right.blue": "Blau rjochts ôfskeane",
  "block.minecraft.banner.diagonal_right.brown": "Brún rjochts ôfskeane",
  "block.minecraft.banner.diagonal_right.cyan": "Syaan rjochts ôfskeane",
  "block.minecraft.banner.diagonal_right.gray": "Griis rjochts ôfskeane",
  "block.minecraft.banner.diagonal_right.green": "Grien rjochts ôfskeane",
  "block.minecraft.banner.diagonal_right.light_blue": "Ljochtblau rjochts ôfskeane",
  "block.minecraft.banner.diagonal_right.light_gray": "Ljochtgriis rjochts ôfskeane",
  "block.minecraft.banner.diagonal_right.lime": "Ljochtgrien rjochts ôfskeane",
  "block.minecraft.banner.diagonal_right.magenta": "Maginta rjochts ôfskeane",
  "block.minecraft.banner.diagonal_right.orange": "Oranje rjochts ôfskeane",
  "block.minecraft.banner.diagonal_right.pink": "Rôze rjochts ôfskeane",
  "block.minecraft.banner.diagonal_right.purple": "Pears rjochts ôfskeane",
  "block.minecraft.banner.diagonal_right.red": "Read rjochts ôfskeane",
  "block.minecraft.banner.diagonal_right.white": "Wyt rjochts ôfskeane",
  "block.minecraft.banner.diagonal_right.yellow": "Giel rjochts ôfskeane",
  "block.minecraft.banner.diagonal_up_left.black": "Swart omkeard rjochts ôfskeane",
  "block.minecraft.banner.diagonal_up_left.blue": "Blau omkeard rjochts ôfskeane",
  "block.minecraft.banner.diagonal_up_left.brown": "Brún omkeard rjochts ôfskeane",
  "block.minecraft.banner.diagonal_up_left.cyan": "Syaan omkeard rjochts ôfskeane",
  "block.minecraft.banner.diagonal_up_left.gray": "Griis omkeard rjochts ôfskeane",
  "block.minecraft.banner.diagonal_up_left.green": "Grien omkeard rjochts ôfskeane",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Ljochtblau omkeard rjochts ôfskeane",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Ljochtgriis omkeard rjochts ôfskeane",
  "block.minecraft.banner.diagonal_up_left.lime": "Ljochtgrien omkeard rjochts ôfskeane",
  "block.minecraft.banner.diagonal_up_left.magenta": "Maginta omkeard rjochts ôfskeane",
  "block.minecraft.banner.diagonal_up_left.orange": "Oranje omkeard rjochts ôfskeane",
  "block.minecraft.banner.diagonal_up_left.pink": "Rôze omkeard rjochts ôfskeane",
  "block.minecraft.banner.diagonal_up_left.purple": "Pears omkeard rjochts ôfskeane",
  "block.minecraft.banner.diagonal_up_left.red": "Read omkeard rjochts ôfskeane",
  "block.minecraft.banner.diagonal_up_left.white": "Wyt omkeard rjochts ôfskeane",
  "block.minecraft.banner.diagonal_up_left.yellow": "Giel omkeard rjochts ôfskeane",
  "block.minecraft.banner.diagonal_up_right.black": "Swart omkeard links ôfskeane",
  "block.minecraft.banner.diagonal_up_right.blue": "Blau omkeard links ôfskeane",
  "block.minecraft.banner.diagonal_up_right.brown": "Brún omkeard links ôfskeane",
  "block.minecraft.banner.diagonal_up_right.cyan": "Syaan omkeard links ôfskeane",
  "block.minecraft.banner.diagonal_up_right.gray": "Griis omkeard links ôfskeane",
  "block.minecraft.banner.diagonal_up_right.green": "Grien omkeard links ôfskeane",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Ljochtblau omkeard links ôfskeane",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Ljochtgriis omkeard links ôfskeane",
  "block.minecraft.banner.diagonal_up_right.lime": "Ljochtgrien omkeard links ôfskeane",
  "block.minecraft.banner.diagonal_up_right.magenta": "Maginta omkeard links ôfskeane",
  "block.minecraft.banner.diagonal_up_right.orange": "Oranje omkeard links ôfskeane",
  "block.minecraft.banner.diagonal_up_right.pink": "Rôze omkeard links ôfskeane",
  "block.minecraft.banner.diagonal_up_right.purple": "Pears omkeard links ôfskeane",
  "block.minecraft.banner.diagonal_up_right.red": "Read omkeard links ôfskeane",
  "block.minecraft.banner.diagonal_up_right.white": "Wyt omkeard links ôfskeane",
  "block.minecraft.banner.diagonal_up_right.yellow": "Giel omkeard links ôfskeane",
  "block.minecraft.banner.flow.black": "Black Flow",
  "block.minecraft.banner.flow.blue": "Blue Flow",
  "block.minecraft.banner.flow.brown": "Brown Flow",
  "block.minecraft.banner.flow.cyan": "Cyan Flow",
  "block.minecraft.banner.flow.gray": "Gray Flow",
  "block.minecraft.banner.flow.green": "Green Flow",
  "block.minecraft.banner.flow.light_blue": "Light Blue Flow",
  "block.minecraft.banner.flow.light_gray": "Light Gray Flow",
  "block.minecraft.banner.flow.lime": "Lime Flow",
  "block.minecraft.banner.flow.magenta": "Magenta Flow",
  "block.minecraft.banner.flow.orange": "Orange Flow",
  "block.minecraft.banner.flow.pink": "Pink Flow",
  "block.minecraft.banner.flow.purple": "Purple Flow",
  "block.minecraft.banner.flow.red": "Red Flow",
  "block.minecraft.banner.flow.white": "White Flow",
  "block.minecraft.banner.flow.yellow": "Yellow Flow",
  "block.minecraft.banner.flower.black": "Swart blomsymboal",
  "block.minecraft.banner.flower.blue": "Blau blomsymboal",
  "block.minecraft.banner.flower.brown": "Brún blomsymboal",
  "block.minecraft.banner.flower.cyan": "Syane blomsymboal",
  "block.minecraft.banner.flower.gray": "Griis blomsymboal",
  "block.minecraft.banner.flower.green": "Grien blomsymboal",
  "block.minecraft.banner.flower.light_blue": "Ljochtblauwe blomsymboal",
  "block.minecraft.banner.flower.light_gray": "Ljochtgriis blomsymboal",
  "block.minecraft.banner.flower.lime": "Ljochtgrien blomsymboal",
  "block.minecraft.banner.flower.magenta": "Maginta blomsymboal",
  "block.minecraft.banner.flower.orange": "Oranje blomsymboal",
  "block.minecraft.banner.flower.pink": "Rôze blomsymboal",
  "block.minecraft.banner.flower.purple": "Pears blomsymboal",
  "block.minecraft.banner.flower.red": "Read blomsymboal",
  "block.minecraft.banner.flower.white": "Wyt blomsymboal",
  "block.minecraft.banner.flower.yellow": "Giel blomsymboal",
  "block.minecraft.banner.globe.black": "Swarte globe",
  "block.minecraft.banner.globe.blue": "Blauwe globe",
  "block.minecraft.banner.globe.brown": "Brune globe",
  "block.minecraft.banner.globe.cyan": "Syane globe",
  "block.minecraft.banner.globe.gray": "Grize globe",
  "block.minecraft.banner.globe.green": "Griene globe",
  "block.minecraft.banner.globe.light_blue": "Ljochtblauwe globe",
  "block.minecraft.banner.globe.light_gray": "Ljochtgrize globe",
  "block.minecraft.banner.globe.lime": "Ljochtgriene globe",
  "block.minecraft.banner.globe.magenta": "Maginta globe",
  "block.minecraft.banner.globe.orange": "Oranje globe",
  "block.minecraft.banner.globe.pink": "Rôze globe",
  "block.minecraft.banner.globe.purple": "Pearze globe",
  "block.minecraft.banner.globe.red": "Reade globe",
  "block.minecraft.banner.globe.white": "Wite globe",
  "block.minecraft.banner.globe.yellow": "Giele globe",
  "block.minecraft.banner.gradient.black": "Swarte hege gradiïnt",
  "block.minecraft.banner.gradient.blue": "Blauwe hege gradiïnt",
  "block.minecraft.banner.gradient.brown": "Brune hege gradiïnt",
  "block.minecraft.banner.gradient.cyan": "Syane hege gradiïnt",
  "block.minecraft.banner.gradient.gray": "Grize hege gradiïnt",
  "block.minecraft.banner.gradient.green": "Griene hege gradiïnt",
  "block.minecraft.banner.gradient.light_blue": "Ljochtblauwe hege gradiïnt",
  "block.minecraft.banner.gradient.light_gray": "Ljochtgrize hege gradiïnt",
  "block.minecraft.banner.gradient.lime": "Ljochtgriene hege gradiïnt",
  "block.minecraft.banner.gradient.magenta": "Maginta hege gradiïnt",
  "block.minecraft.banner.gradient.orange": "Oranje hege gradiïnt",
  "block.minecraft.banner.gradient.pink": "Rôze hege gradiïnt",
  "block.minecraft.banner.gradient.purple": "Pearze hege gradiïnt",
  "block.minecraft.banner.gradient.red": "Reade hege gradiïnt",
  "block.minecraft.banner.gradient.white": "Wite hege gradiïnt",
  "block.minecraft.banner.gradient.yellow": "Giele hege gradiïnt",
  "block.minecraft.banner.gradient_up.black": "Swarte lege gradiïnt",
  "block.minecraft.banner.gradient_up.blue": "Blauwe lege gradiïnt",
  "block.minecraft.banner.gradient_up.brown": "Brune lege gradiïnt",
  "block.minecraft.banner.gradient_up.cyan": "Syane lege gradiïnt",
  "block.minecraft.banner.gradient_up.gray": "Grize lege gradiïnt",
  "block.minecraft.banner.gradient_up.green": "Griene lege gradiïnt",
  "block.minecraft.banner.gradient_up.light_blue": "Ljochtblauwe lege gradiïnt",
  "block.minecraft.banner.gradient_up.light_gray": "Ljochtgrize lege gradiïnt",
  "block.minecraft.banner.gradient_up.lime": "Ljochtgriene lege gradiïnt",
  "block.minecraft.banner.gradient_up.magenta": "Maginta lege gradiïnt",
  "block.minecraft.banner.gradient_up.orange": "Oranje lege gradiïnt",
  "block.minecraft.banner.gradient_up.pink": "Rôze lege gradiïnt",
  "block.minecraft.banner.gradient_up.purple": "Pearze lege gradiïnt",
  "block.minecraft.banner.gradient_up.red": "Reade lege gradiïnt",
  "block.minecraft.banner.gradient_up.white": "Wite lege gradiïnt",
  "block.minecraft.banner.gradient_up.yellow": "Giele lege gradiïnt",
  "block.minecraft.banner.guster.black": "Black Guster",
  "block.minecraft.banner.guster.blue": "Blue Guster",
  "block.minecraft.banner.guster.brown": "Brown Guster",
  "block.minecraft.banner.guster.cyan": "Cyan Guster",
  "block.minecraft.banner.guster.gray": "Gray Guster",
  "block.minecraft.banner.guster.green": "Green Guster",
  "block.minecraft.banner.guster.light_blue": "Light Blue Guster",
  "block.minecraft.banner.guster.light_gray": "Light Gray Guster",
  "block.minecraft.banner.guster.lime": "Lime Guster",
  "block.minecraft.banner.guster.magenta": "Magenta Guster",
  "block.minecraft.banner.guster.orange": "Orange Guster",
  "block.minecraft.banner.guster.pink": "Pink Guster",
  "block.minecraft.banner.guster.purple": "Purple Guster",
  "block.minecraft.banner.guster.red": "Red Guster",
  "block.minecraft.banner.guster.white": "White Guster",
  "block.minecraft.banner.guster.yellow": "Yellow Guster",
  "block.minecraft.banner.half_horizontal.black": "Swarte dwersbalke",
  "block.minecraft.banner.half_horizontal.blue": "Blauwe dwersbalke",
  "block.minecraft.banner.half_horizontal.brown": "Brune dwersbalke",
  "block.minecraft.banner.half_horizontal.cyan": "Syane dwersbalke",
  "block.minecraft.banner.half_horizontal.gray": "Grize dwersbalke",
  "block.minecraft.banner.half_horizontal.green": "Griene dwersbalke",
  "block.minecraft.banner.half_horizontal.light_blue": "Ljochtblauwe dwersbalke",
  "block.minecraft.banner.half_horizontal.light_gray": "Ljochtgrize dwersbalke",
  "block.minecraft.banner.half_horizontal.lime": "Ljochtgriene dwersbalke",
  "block.minecraft.banner.half_horizontal.magenta": "Maginta dwersbalke",
  "block.minecraft.banner.half_horizontal.orange": "Oranje dwersbalke",
  "block.minecraft.banner.half_horizontal.pink": "Rôze dwersbalke",
  "block.minecraft.banner.half_horizontal.purple": "Pearze dwersbalke",
  "block.minecraft.banner.half_horizontal.red": "Reade dwersbalke",
  "block.minecraft.banner.half_horizontal.white": "Wite dwersbalke",
  "block.minecraft.banner.half_horizontal.yellow": "Giele dwersbalke",
  "block.minecraft.banner.half_horizontal_bottom.black": "Swart omkearde dwersbalke",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Blau omkearde dwersbalke",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Brún omkearde dwersbalke",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Syane omkearde dwersbalke",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Griis omkearde dwersbalke",
  "block.minecraft.banner.half_horizontal_bottom.green": "Grien omkearde dwersbalke",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Ljochtblau omkearde dwersbalke",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Ljochtgriis omkearde dwersbalke",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Ljochtgrien omkearde dwersbalke",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Maginta omkearde dwersbalke",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Oranje omkearde dwersbalke",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Rôze omkearde dwersbalke",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Pears omkearde dwersbalke",
  "block.minecraft.banner.half_horizontal_bottom.red": "Read omkearde dwersbalke",
  "block.minecraft.banner.half_horizontal_bottom.white": "Wyt omkearde dwersbalke",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Giel omkearde dwersbalke",
  "block.minecraft.banner.half_vertical.black": "Swarte peal",
  "block.minecraft.banner.half_vertical.blue": "Blauwe peal",
  "block.minecraft.banner.half_vertical.brown": "Brune peal",
  "block.minecraft.banner.half_vertical.cyan": "Syane peal",
  "block.minecraft.banner.half_vertical.gray": "Grize peal",
  "block.minecraft.banner.half_vertical.green": "Griene peal",
  "block.minecraft.banner.half_vertical.light_blue": "Ljochtblauwe peal",
  "block.minecraft.banner.half_vertical.light_gray": "Ljochtgrize peal",
  "block.minecraft.banner.half_vertical.lime": "Ljochtgriene peal",
  "block.minecraft.banner.half_vertical.magenta": "Maginta peal",
  "block.minecraft.banner.half_vertical.orange": "Oranje peal",
  "block.minecraft.banner.half_vertical.pink": "Rôze peal",
  "block.minecraft.banner.half_vertical.purple": "Pearze peal",
  "block.minecraft.banner.half_vertical.red": "Reade peal",
  "block.minecraft.banner.half_vertical.white": "Wite peal",
  "block.minecraft.banner.half_vertical.yellow": "Giele peal",
  "block.minecraft.banner.half_vertical_right.black": "Swart omkearde peal",
  "block.minecraft.banner.half_vertical_right.blue": "Blau omkearde peal",
  "block.minecraft.banner.half_vertical_right.brown": "Brún omkearde peal",
  "block.minecraft.banner.half_vertical_right.cyan": "Syane omkearde peal",
  "block.minecraft.banner.half_vertical_right.gray": "Griis omkearde peal",
  "block.minecraft.banner.half_vertical_right.green": "Grien omkearde peal",
  "block.minecraft.banner.half_vertical_right.light_blue": "Ljochtblau omkearde peal",
  "block.minecraft.banner.half_vertical_right.light_gray": "Ljochtgriis omkearde peal",
  "block.minecraft.banner.half_vertical_right.lime": "Ljochtgrien omkearde peal",
  "block.minecraft.banner.half_vertical_right.magenta": "Maginta omkearde peal",
  "block.minecraft.banner.half_vertical_right.orange": "Oranje omkearde peal",
  "block.minecraft.banner.half_vertical_right.pink": "Rôze omkearde peal",
  "block.minecraft.banner.half_vertical_right.purple": "Pears omkearde peal",
  "block.minecraft.banner.half_vertical_right.red": "Read omkearde peal",
  "block.minecraft.banner.half_vertical_right.white": "Wyt omkearde peal",
  "block.minecraft.banner.half_vertical_right.yellow": "Giel omkearde peal",
  "block.minecraft.banner.mojang.black": "Swart Mojang-symboal",
  "block.minecraft.banner.mojang.blue": "Blau Mojang-symboal",
  "block.minecraft.banner.mojang.brown": "Brún Mojang-symboal",
  "block.minecraft.banner.mojang.cyan": "Syane Mojang-symboal",
  "block.minecraft.banner.mojang.gray": "Griis Mojang-symboal",
  "block.minecraft.banner.mojang.green": "Grien Mojang-symboal",
  "block.minecraft.banner.mojang.light_blue": "Ljochtblau Mojang-symboal",
  "block.minecraft.banner.mojang.light_gray": "Ljochtgriis Mojang-symboal",
  "block.minecraft.banner.mojang.lime": "Ljochtgrien Mojang-symboal",
  "block.minecraft.banner.mojang.magenta": "Maginta Mojang-symboal",
  "block.minecraft.banner.mojang.orange": "Oranje Mojang-symboal",
  "block.minecraft.banner.mojang.pink": "Rôze Mojang-symboal",
  "block.minecraft.banner.mojang.purple": "Pears Mojang-symboal",
  "block.minecraft.banner.mojang.red": "Read Mojang-symboal",
  "block.minecraft.banner.mojang.white": "Wyt Mojang-symboal",
  "block.minecraft.banner.mojang.yellow": "Giel Mojang-symboal",
  "block.minecraft.banner.piglin.black": "Swarte snút",
  "block.minecraft.banner.piglin.blue": "Blauwe snút",
  "block.minecraft.banner.piglin.brown": "Brune snút",
  "block.minecraft.banner.piglin.cyan": "Turkoaiske snút",
  "block.minecraft.banner.piglin.gray": "Grize snút",
  "block.minecraft.banner.piglin.green": "Griene snút",
  "block.minecraft.banner.piglin.light_blue": "Ljochtblauwe snút",
  "block.minecraft.banner.piglin.light_gray": "Ljochtgrize snút",
  "block.minecraft.banner.piglin.lime": "Ljochtgriene snút",
  "block.minecraft.banner.piglin.magenta": "Maginta snút",
  "block.minecraft.banner.piglin.orange": "Oranje snút",
  "block.minecraft.banner.piglin.pink": "Rôze snút",
  "block.minecraft.banner.piglin.purple": "Pearsen snút",
  "block.minecraft.banner.piglin.red": "Reade snút",
  "block.minecraft.banner.piglin.white": "Wite snút",
  "block.minecraft.banner.piglin.yellow": "Giele snút",
  "block.minecraft.banner.rhombus.black": "Swart rút",
  "block.minecraft.banner.rhombus.blue": "Blau rút",
  "block.minecraft.banner.rhombus.brown": "Brún rút",
  "block.minecraft.banner.rhombus.cyan": "Syaan rút",
  "block.minecraft.banner.rhombus.gray": "Griis rút",
  "block.minecraft.banner.rhombus.green": "Grien rút",
  "block.minecraft.banner.rhombus.light_blue": "Ljochtblau rút",
  "block.minecraft.banner.rhombus.light_gray": "Ljochtgriis rút",
  "block.minecraft.banner.rhombus.lime": "Ljochtgrien rút",
  "block.minecraft.banner.rhombus.magenta": "Maginta rút",
  "block.minecraft.banner.rhombus.orange": "Oranje rút",
  "block.minecraft.banner.rhombus.pink": "Rôze rút",
  "block.minecraft.banner.rhombus.purple": "Pears rút",
  "block.minecraft.banner.rhombus.red": "Read rút",
  "block.minecraft.banner.rhombus.white": "Wyt rút",
  "block.minecraft.banner.rhombus.yellow": "Giel rút",
  "block.minecraft.banner.skull.black": "Swarte deadskop",
  "block.minecraft.banner.skull.blue": "Blauwe deadskop",
  "block.minecraft.banner.skull.brown": "Brune deadskop",
  "block.minecraft.banner.skull.cyan": "Syane deadskop",
  "block.minecraft.banner.skull.gray": "Grize deadskop",
  "block.minecraft.banner.skull.green": "Griene deadskop",
  "block.minecraft.banner.skull.light_blue": "Ljochtblauwe deadskop",
  "block.minecraft.banner.skull.light_gray": "Ljochtgrize deadskop",
  "block.minecraft.banner.skull.lime": "Ljochtgriene deadskop",
  "block.minecraft.banner.skull.magenta": "Maginta deadskop",
  "block.minecraft.banner.skull.orange": "Oranje deadskop",
  "block.minecraft.banner.skull.pink": "Rôze deadskop",
  "block.minecraft.banner.skull.purple": "Pearze deadskop",
  "block.minecraft.banner.skull.red": "Reade deadskop",
  "block.minecraft.banner.skull.white": "Wite deadskop",
  "block.minecraft.banner.skull.yellow": "Giele deadskop",
  "block.minecraft.banner.small_stripes.black": "Swarte peallen",
  "block.minecraft.banner.small_stripes.blue": "Blauwe peallen",
  "block.minecraft.banner.small_stripes.brown": "Brune peallen",
  "block.minecraft.banner.small_stripes.cyan": "Syane peallen",
  "block.minecraft.banner.small_stripes.gray": "Grize peallen",
  "block.minecraft.banner.small_stripes.green": "Griene peallen",
  "block.minecraft.banner.small_stripes.light_blue": "Ljochtblauwe peallen",
  "block.minecraft.banner.small_stripes.light_gray": "Ljochtgrize peallen",
  "block.minecraft.banner.small_stripes.lime": "Ljochtgriene peallen",
  "block.minecraft.banner.small_stripes.magenta": "Maginta peallen",
  "block.minecraft.banner.small_stripes.orange": "Oranje peallen",
  "block.minecraft.banner.small_stripes.pink": "Rôze peallen",
  "block.minecraft.banner.small_stripes.purple": "Pearze peallen",
  "block.minecraft.banner.small_stripes.red": "Reade peallen",
  "block.minecraft.banner.small_stripes.white": "Wite peallen",
  "block.minecraft.banner.small_stripes.yellow": "Giele peallen",
  "block.minecraft.banner.square_bottom_left.black": "Swart kanton rjochts ûnder",
  "block.minecraft.banner.square_bottom_left.blue": "Blau kanton rjochts ûnder",
  "block.minecraft.banner.square_bottom_left.brown": "Brún kanton rjochts ûnder",
  "block.minecraft.banner.square_bottom_left.cyan": "Syaan leech kanton oan de rjochterkant",
  "block.minecraft.banner.square_bottom_left.gray": "Griis kanton rjochts ûnder",
  "block.minecraft.banner.square_bottom_left.green": "Grien kanton rjochts ûnder",
  "block.minecraft.banner.square_bottom_left.light_blue": "Ljochtblau kanton rjochts ûnder",
  "block.minecraft.banner.square_bottom_left.light_gray": "Ljochtgriis kanton rjochts ûnder",
  "block.minecraft.banner.square_bottom_left.lime": "Ljochtgrien kanton rjochts ûnder",
  "block.minecraft.banner.square_bottom_left.magenta": "Maginta kanton rjochts ûnder",
  "block.minecraft.banner.square_bottom_left.orange": "Oranje kanton rjochts ûnder",
  "block.minecraft.banner.square_bottom_left.pink": "Rôze kanton rjochts ûnder",
  "block.minecraft.banner.square_bottom_left.purple": "Pears kanton rjochts ûnder",
  "block.minecraft.banner.square_bottom_left.red": "Read kanton rjochts ûnder",
  "block.minecraft.banner.square_bottom_left.white": "Wyt kanton rjochts ûnder",
  "block.minecraft.banner.square_bottom_left.yellow": "Giel kanton rjochts ûnder",
  "block.minecraft.banner.square_bottom_right.black": "Swart kanton links ûnder",
  "block.minecraft.banner.square_bottom_right.blue": "Blau kanton links ûnder",
  "block.minecraft.banner.square_bottom_right.brown": "Brún kanton links ûnder",
  "block.minecraft.banner.square_bottom_right.cyan": "Syaan leech kanton oan de lofterkant",
  "block.minecraft.banner.square_bottom_right.gray": "Griis kanton links ûnder",
  "block.minecraft.banner.square_bottom_right.green": "Grien kanton links ûnder",
  "block.minecraft.banner.square_bottom_right.light_blue": "Ljochtblau kanton links ûnder",
  "block.minecraft.banner.square_bottom_right.light_gray": "Ljochtgriis kanton links ûnder",
  "block.minecraft.banner.square_bottom_right.lime": "Ljochtgrien kanton links ûnder",
  "block.minecraft.banner.square_bottom_right.magenta": "Maginta kanton links ûnder",
  "block.minecraft.banner.square_bottom_right.orange": "Oranje kanton links ûnder",
  "block.minecraft.banner.square_bottom_right.pink": "Rôze kanton links ûnder",
  "block.minecraft.banner.square_bottom_right.purple": "Pears kanton links ûnder",
  "block.minecraft.banner.square_bottom_right.red": "Read kanton links ûnder",
  "block.minecraft.banner.square_bottom_right.white": "Wyt kanton links ûnder",
  "block.minecraft.banner.square_bottom_right.yellow": "Giel kanton links ûnder",
  "block.minecraft.banner.square_top_left.black": "Swart kanton rjochts boppe",
  "block.minecraft.banner.square_top_left.blue": "Blau kanton rjochts boppe",
  "block.minecraft.banner.square_top_left.brown": "Brún kanton rjochts boppe",
  "block.minecraft.banner.square_top_left.cyan": "Syaan heech kanton oan de rjochterkant",
  "block.minecraft.banner.square_top_left.gray": "Griis kanton rjochts boppe",
  "block.minecraft.banner.square_top_left.green": "Grien kanton rjochts boppe",
  "block.minecraft.banner.square_top_left.light_blue": "Ljochtblau kanton rjochts boppe",
  "block.minecraft.banner.square_top_left.light_gray": "Ljochtgriis kanton rjochts boppe",
  "block.minecraft.banner.square_top_left.lime": "Ljochtgrien kanton rjochts boppe",
  "block.minecraft.banner.square_top_left.magenta": "Maginta kanton rjochts boppe",
  "block.minecraft.banner.square_top_left.orange": "Oranje kanton rjochts boppe",
  "block.minecraft.banner.square_top_left.pink": "Rôze kanton rjochts boppe",
  "block.minecraft.banner.square_top_left.purple": "Pears kanton rjochts boppe",
  "block.minecraft.banner.square_top_left.red": "Read kanton rjochts boppe",
  "block.minecraft.banner.square_top_left.white": "Wyt kanton rjochts boppe",
  "block.minecraft.banner.square_top_left.yellow": "Giel kanton rjochts boppe",
  "block.minecraft.banner.square_top_right.black": "Swart kanton links boppe",
  "block.minecraft.banner.square_top_right.blue": "Blau kanton links boppe",
  "block.minecraft.banner.square_top_right.brown": "Brún kanton links boppe",
  "block.minecraft.banner.square_top_right.cyan": "Syaan heech kanton oan de lofterkant",
  "block.minecraft.banner.square_top_right.gray": "Griis kanton lofts boppe",
  "block.minecraft.banner.square_top_right.green": "Grien kanton links boppe",
  "block.minecraft.banner.square_top_right.light_blue": "Ljochtblau kanton lofts boppe",
  "block.minecraft.banner.square_top_right.light_gray": "Ljochtgriis kanton lofts boppe",
  "block.minecraft.banner.square_top_right.lime": "Ljochtgrien kanton lofts boppe",
  "block.minecraft.banner.square_top_right.magenta": "Maginta kanton lofts boppe",
  "block.minecraft.banner.square_top_right.orange": "Oranje kanton lofts boppe",
  "block.minecraft.banner.square_top_right.pink": "Rôze kanton lofts boppe",
  "block.minecraft.banner.square_top_right.purple": "Pears kanton links boppe",
  "block.minecraft.banner.square_top_right.red": "Read kanton links boppe",
  "block.minecraft.banner.square_top_right.white": "Wyt kanton lofts boppe",
  "block.minecraft.banner.square_top_right.yellow": "Giel kanton lofts boppe",
  "block.minecraft.banner.straight_cross.black": "Swart krús",
  "block.minecraft.banner.straight_cross.blue": "Blau krús",
  "block.minecraft.banner.straight_cross.brown": "Brún krús",
  "block.minecraft.banner.straight_cross.cyan": "Syane krús",
  "block.minecraft.banner.straight_cross.gray": "Griis krús",
  "block.minecraft.banner.straight_cross.green": "Grien krús",
  "block.minecraft.banner.straight_cross.light_blue": "Ljochtblau krús",
  "block.minecraft.banner.straight_cross.light_gray": "Ljochtgriis krús",
  "block.minecraft.banner.straight_cross.lime": "Ljochtgrien krús",
  "block.minecraft.banner.straight_cross.magenta": "Maginta krús",
  "block.minecraft.banner.straight_cross.orange": "Oranje krús",
  "block.minecraft.banner.straight_cross.pink": "Rôze krús",
  "block.minecraft.banner.straight_cross.purple": "Pears krús",
  "block.minecraft.banner.straight_cross.red": "Read krús",
  "block.minecraft.banner.straight_cross.white": "Wyt krús",
  "block.minecraft.banner.straight_cross.yellow": "Giel krús",
  "block.minecraft.banner.stripe_bottom.black": "Swarte basis",
  "block.minecraft.banner.stripe_bottom.blue": "Blauwe basis",
  "block.minecraft.banner.stripe_bottom.brown": "Brune basis",
  "block.minecraft.banner.stripe_bottom.cyan": "Syane basis",
  "block.minecraft.banner.stripe_bottom.gray": "Grize basis",
  "block.minecraft.banner.stripe_bottom.green": "Griene basis",
  "block.minecraft.banner.stripe_bottom.light_blue": "Ljochtblauwe basis",
  "block.minecraft.banner.stripe_bottom.light_gray": "Ljochtgrize basis",
  "block.minecraft.banner.stripe_bottom.lime": "Ljochtgriene basis",
  "block.minecraft.banner.stripe_bottom.magenta": "Maginta basis",
  "block.minecraft.banner.stripe_bottom.orange": "Oranje basis",
  "block.minecraft.banner.stripe_bottom.pink": "Rôze basis",
  "block.minecraft.banner.stripe_bottom.purple": "Pearze basis",
  "block.minecraft.banner.stripe_bottom.red": "Reade basis",
  "block.minecraft.banner.stripe_bottom.white": "Wite basis",
  "block.minecraft.banner.stripe_bottom.yellow": "Giele basis",
  "block.minecraft.banner.stripe_center.black": "Swarte peal",
  "block.minecraft.banner.stripe_center.blue": "Blauwe peal",
  "block.minecraft.banner.stripe_center.brown": "Brune peal",
  "block.minecraft.banner.stripe_center.cyan": "Syane peal",
  "block.minecraft.banner.stripe_center.gray": "Grize peal",
  "block.minecraft.banner.stripe_center.green": "Griene peal",
  "block.minecraft.banner.stripe_center.light_blue": "Ljochtblauwe peal",
  "block.minecraft.banner.stripe_center.light_gray": "Ljochtgrize peal",
  "block.minecraft.banner.stripe_center.lime": "Ljochtgriene peal",
  "block.minecraft.banner.stripe_center.magenta": "Maginta peal",
  "block.minecraft.banner.stripe_center.orange": "Oranje peal",
  "block.minecraft.banner.stripe_center.pink": "Rôze peal",
  "block.minecraft.banner.stripe_center.purple": "Pearze peal",
  "block.minecraft.banner.stripe_center.red": "Reade peal",
  "block.minecraft.banner.stripe_center.white": "Wite peal",
  "block.minecraft.banner.stripe_center.yellow": "Giele peal",
  "block.minecraft.banner.stripe_downleft.black": "Swarte baan links",
  "block.minecraft.banner.stripe_downleft.blue": "Blauwe baan links",
  "block.minecraft.banner.stripe_downleft.brown": "Brune baan links",
  "block.minecraft.banner.stripe_downleft.cyan": "Syane loftsskeane baan",
  "block.minecraft.banner.stripe_downleft.gray": "Grize baan links",
  "block.minecraft.banner.stripe_downleft.green": "Griene baan links",
  "block.minecraft.banner.stripe_downleft.light_blue": "Ljochtblauwe baan links",
  "block.minecraft.banner.stripe_downleft.light_gray": "Ljochtgrize baan links",
  "block.minecraft.banner.stripe_downleft.lime": "Ljochtgriene baan links",
  "block.minecraft.banner.stripe_downleft.magenta": "Maginta baan links",
  "block.minecraft.banner.stripe_downleft.orange": "Oranje baan links",
  "block.minecraft.banner.stripe_downleft.pink": "Rôze baan links",
  "block.minecraft.banner.stripe_downleft.purple": "Pearze baan links",
  "block.minecraft.banner.stripe_downleft.red": "Reade baan links",
  "block.minecraft.banner.stripe_downleft.white": "Wite baan links",
  "block.minecraft.banner.stripe_downleft.yellow": "Giele baan links",
  "block.minecraft.banner.stripe_downright.black": "Swarte baan",
  "block.minecraft.banner.stripe_downright.blue": "Blauwe baan",
  "block.minecraft.banner.stripe_downright.brown": "Brune baan",
  "block.minecraft.banner.stripe_downright.cyan": "Syane baan",
  "block.minecraft.banner.stripe_downright.gray": "Grize baan",
  "block.minecraft.banner.stripe_downright.green": "Griene baan",
  "block.minecraft.banner.stripe_downright.light_blue": "Ljochtblauwe baan",
  "block.minecraft.banner.stripe_downright.light_gray": "Ljochtgrize baan",
  "block.minecraft.banner.stripe_downright.lime": "Ljochtgriene baan",
  "block.minecraft.banner.stripe_downright.magenta": "Maginta baan",
  "block.minecraft.banner.stripe_downright.orange": "Oranje baan",
  "block.minecraft.banner.stripe_downright.pink": "Rôze baan",
  "block.minecraft.banner.stripe_downright.purple": "Pearze baan",
  "block.minecraft.banner.stripe_downright.red": "Reade baan",
  "block.minecraft.banner.stripe_downright.white": "Wite baan",
  "block.minecraft.banner.stripe_downright.yellow": "Giele baan",
  "block.minecraft.banner.stripe_left.black": "Swarte peal rjochts",
  "block.minecraft.banner.stripe_left.blue": "Blauwe peal rjochts",
  "block.minecraft.banner.stripe_left.brown": "Brune peal rjochts",
  "block.minecraft.banner.stripe_left.cyan": "Syane peal oan de rjochterkant",
  "block.minecraft.banner.stripe_left.gray": "Grize peal rjochts",
  "block.minecraft.banner.stripe_left.green": "Griene peal rjochts",
  "block.minecraft.banner.stripe_left.light_blue": "Ljochtblauwe peal rjochts",
  "block.minecraft.banner.stripe_left.light_gray": "Ljochtgrize peal rjochts",
  "block.minecraft.banner.stripe_left.lime": "Ljochtgriene peal rjochts",
  "block.minecraft.banner.stripe_left.magenta": "Maginta peal rjochts",
  "block.minecraft.banner.stripe_left.orange": "Oranje peal rjochts",
  "block.minecraft.banner.stripe_left.pink": "Rôze peal rjochts",
  "block.minecraft.banner.stripe_left.purple": "Pearze peal rjochts",
  "block.minecraft.banner.stripe_left.red": "Reade peal rjochts",
  "block.minecraft.banner.stripe_left.white": "Wite peal rjochts",
  "block.minecraft.banner.stripe_left.yellow": "Giele peal rjochts",
  "block.minecraft.banner.stripe_middle.black": "Swarte dwersbalke",
  "block.minecraft.banner.stripe_middle.blue": "Blauwe dwersbalke",
  "block.minecraft.banner.stripe_middle.brown": "Brune dwersbalke",
  "block.minecraft.banner.stripe_middle.cyan": "Syane dwersbalke",
  "block.minecraft.banner.stripe_middle.gray": "Grize dwersbalke",
  "block.minecraft.banner.stripe_middle.green": "Griene dwersbalke",
  "block.minecraft.banner.stripe_middle.light_blue": "Ljochtblauwe dwersbalke",
  "block.minecraft.banner.stripe_middle.light_gray": "Ljochtgrize dwersbalke",
  "block.minecraft.banner.stripe_middle.lime": "Ljochtgriene dwersbalke",
  "block.minecraft.banner.stripe_middle.magenta": "Maginta dwersbalke",
  "block.minecraft.banner.stripe_middle.orange": "Oranje dwersbalke",
  "block.minecraft.banner.stripe_middle.pink": "Rôze dwersbalke",
  "block.minecraft.banner.stripe_middle.purple": "Pearze dwersbalke",
  "block.minecraft.banner.stripe_middle.red": "Reade dwersbalke",
  "block.minecraft.banner.stripe_middle.white": "Wite dwersbalke",
  "block.minecraft.banner.stripe_middle.yellow": "Giele dwersbalke",
  "block.minecraft.banner.stripe_right.black": "Swarte peal lofts",
  "block.minecraft.banner.stripe_right.blue": "Blauwe peal lofts",
  "block.minecraft.banner.stripe_right.brown": "Brune peal lofts",
  "block.minecraft.banner.stripe_right.cyan": "Syane peal oan de lofterkant",
  "block.minecraft.banner.stripe_right.gray": "Grize peal lofts",
  "block.minecraft.banner.stripe_right.green": "Griene peal lofts",
  "block.minecraft.banner.stripe_right.light_blue": "Ljochtblauwe peal lofts",
  "block.minecraft.banner.stripe_right.light_gray": "Ljochtgrize peal lofts",
  "block.minecraft.banner.stripe_right.lime": "Ljochtgriene peal lofts",
  "block.minecraft.banner.stripe_right.magenta": "Maginta peal lofts",
  "block.minecraft.banner.stripe_right.orange": "Oranje peal lofts",
  "block.minecraft.banner.stripe_right.pink": "Rôze peal lofts",
  "block.minecraft.banner.stripe_right.purple": "Pearze peal lofts",
  "block.minecraft.banner.stripe_right.red": "Reade peal lofts",
  "block.minecraft.banner.stripe_right.white": "Wite peal lofts",
  "block.minecraft.banner.stripe_right.yellow": "Giele peal lofts",
  "block.minecraft.banner.stripe_top.black": "Swarte top",
  "block.minecraft.banner.stripe_top.blue": "Blauwe top",
  "block.minecraft.banner.stripe_top.brown": "Brune top",
  "block.minecraft.banner.stripe_top.cyan": "Syane top",
  "block.minecraft.banner.stripe_top.gray": "Grize top",
  "block.minecraft.banner.stripe_top.green": "Griene top",
  "block.minecraft.banner.stripe_top.light_blue": "Ljochtblauwe top",
  "block.minecraft.banner.stripe_top.light_gray": "Ljochtgrize top",
  "block.minecraft.banner.stripe_top.lime": "Ljochtgriene top",
  "block.minecraft.banner.stripe_top.magenta": "Maginta top",
  "block.minecraft.banner.stripe_top.orange": "Oranje top",
  "block.minecraft.banner.stripe_top.pink": "Rôze top",
  "block.minecraft.banner.stripe_top.purple": "Pearze top",
  "block.minecraft.banner.stripe_top.red": "Reade top",
  "block.minecraft.banner.stripe_top.white": "Wite top",
  "block.minecraft.banner.stripe_top.yellow": "Giele top",
  "block.minecraft.banner.triangle_bottom.black": "Swarte keper",
  "block.minecraft.banner.triangle_bottom.blue": "Blauwe keper",
  "block.minecraft.banner.triangle_bottom.brown": "Brune keper",
  "block.minecraft.banner.triangle_bottom.cyan": "Syane keper",
  "block.minecraft.banner.triangle_bottom.gray": "Grize keper",
  "block.minecraft.banner.triangle_bottom.green": "Griene keper",
  "block.minecraft.banner.triangle_bottom.light_blue": "Ljochtblauwe keper",
  "block.minecraft.banner.triangle_bottom.light_gray": "Ljochtgrize keper",
  "block.minecraft.banner.triangle_bottom.lime": "Ljochtgriene keper",
  "block.minecraft.banner.triangle_bottom.magenta": "Maginta keper",
  "block.minecraft.banner.triangle_bottom.orange": "Oranje keper",
  "block.minecraft.banner.triangle_bottom.pink": "Rôze keper",
  "block.minecraft.banner.triangle_bottom.purple": "Pearze keper",
  "block.minecraft.banner.triangle_bottom.red": "Reade keper",
  "block.minecraft.banner.triangle_bottom.white": "Wite keper",
  "block.minecraft.banner.triangle_bottom.yellow": "Giele keper",
  "block.minecraft.banner.triangle_top.black": "Swarte omkearde keper",
  "block.minecraft.banner.triangle_top.blue": "Blauwe omkearde keper",
  "block.minecraft.banner.triangle_top.brown": "Brune omkearde keper",
  "block.minecraft.banner.triangle_top.cyan": "Syane omkearde keper",
  "block.minecraft.banner.triangle_top.gray": "Grize omkearde keper",
  "block.minecraft.banner.triangle_top.green": "Griene omkearde keper",
  "block.minecraft.banner.triangle_top.light_blue": "Ljochtblauwe omkearde keper",
  "block.minecraft.banner.triangle_top.light_gray": "Ljochtgrize omkearde keper",
  "block.minecraft.banner.triangle_top.lime": "Ljochtgriene omkearde keper",
  "block.minecraft.banner.triangle_top.magenta": "Maginta omkearde keper",
  "block.minecraft.banner.triangle_top.orange": "Oranje omkearde keper",
  "block.minecraft.banner.triangle_top.pink": "Rôze omkearde keper",
  "block.minecraft.banner.triangle_top.purple": "Pearze omkearde keper",
  "block.minecraft.banner.triangle_top.red": "Reade omkearde keper",
  "block.minecraft.banner.triangle_top.white": "Wite omkearde keper",
  "block.minecraft.banner.triangle_top.yellow": "Giele omkearde keper",
  "block.minecraft.banner.triangles_bottom.black": "Swart ynkepe basis",
  "block.minecraft.banner.triangles_bottom.blue": "Blau ynkepe basis",
  "block.minecraft.banner.triangles_bottom.brown": "Brún ynkepe basis",
  "block.minecraft.banner.triangles_bottom.cyan": "Syane ynkepe basis",
  "block.minecraft.banner.triangles_bottom.gray": "Griis ynkepe basis",
  "block.minecraft.banner.triangles_bottom.green": "Grien ynkepe basis",
  "block.minecraft.banner.triangles_bottom.light_blue": "Ljochtblau ynkepe basis",
  "block.minecraft.banner.triangles_bottom.light_gray": "Ljochtgriis ynkepe basis",
  "block.minecraft.banner.triangles_bottom.lime": "Ljochtgrien ynkepe basis",
  "block.minecraft.banner.triangles_bottom.magenta": "Maginta ynkepe basis",
  "block.minecraft.banner.triangles_bottom.orange": "Oranje ynkepe basis",
  "block.minecraft.banner.triangles_bottom.pink": "Rôze ynkepe basis",
  "block.minecraft.banner.triangles_bottom.purple": "Pears ynkepe basis",
  "block.minecraft.banner.triangles_bottom.red": "Read ynkepe basis",
  "block.minecraft.banner.triangles_bottom.white": "Wyt ynkepe basis",
  "block.minecraft.banner.triangles_bottom.yellow": "Giel ynkepe basis",
  "block.minecraft.banner.triangles_top.black": "Swart ynkepe boppekant",
  "block.minecraft.banner.triangles_top.blue": "Blau ynkepe boppekant",
  "block.minecraft.banner.triangles_top.brown": "Brún ynkepe boppekant",
  "block.minecraft.banner.triangles_top.cyan": "Syane ynkepe boppekant",
  "block.minecraft.banner.triangles_top.gray": "Griis ynkepe boppekant",
  "block.minecraft.banner.triangles_top.green": "Grien ynkepe boppekant",
  "block.minecraft.banner.triangles_top.light_blue": "Ljochtblau ynkepe boppekant",
  "block.minecraft.banner.triangles_top.light_gray": "Ljochtgriis ynkepe boppekant",
  "block.minecraft.banner.triangles_top.lime": "Ljochtgrien ynkepe boppekant",
  "block.minecraft.banner.triangles_top.magenta": "Magenta ynkepe boppekant",
  "block.minecraft.banner.triangles_top.orange": "Oranje ynkepe boppekant",
  "block.minecraft.banner.triangles_top.pink": "Rôze ynkepe boppekant",
  "block.minecraft.banner.triangles_top.purple": "Pears ynkepe boppekant",
  "block.minecraft.banner.triangles_top.red": "Read ynkepe boppekant",
  "block.minecraft.banner.triangles_top.white": "Wyt ynkepe boppekant",
  "block.minecraft.banner.triangles_top.yellow": "Giel ynkepe boppekant",
  "block.minecraft.barrel": "Fet",
  "block.minecraft.barrier": "Barriêre",
  "block.minecraft.basalt": "Basalt",
  "block.minecraft.beacon": "Beaken",
  "block.minecraft.beacon.primary": "Primêre krêft",
  "block.minecraft.beacon.secondary": "Sekundêre krêft",
  "block.minecraft.bed.no_sleep": "Do kinst allinnich nachts of wylst swier waar sliepe",
  "block.minecraft.bed.not_safe": "Do kinst no net rêste; der binne meunsters yn de buert",
  "block.minecraft.bed.obstructed": "Dit bêd is blokkearre",
  "block.minecraft.bed.occupied": "Dit bêd wurdt al brûkt",
  "block.minecraft.bed.too_far_away": "Do kinst no net rêste; it bêd is te fier fuort",
  "block.minecraft.bedrock": "Boaiemstien",
  "block.minecraft.bee_nest": "Bijenêst",
  "block.minecraft.beehive": "Bijekoer",
  "block.minecraft.beetroots": "Biten",
  "block.minecraft.bell": "Bel",
  "block.minecraft.big_dripleaf": "Grut dripblêd",
  "block.minecraft.big_dripleaf_stem": "Grut dripblêdstâl",
  "block.minecraft.birch_button": "Bjirkehouten knop",
  "block.minecraft.birch_door": "Bjirkehouten doar",
  "block.minecraft.birch_fence": "Bjirkehouten stek",
  "block.minecraft.birch_fence_gate": "Bjirkehouten stekpoartsje",
  "block.minecraft.birch_hanging_sign": "Bjirkehouten úthingboerd",
  "block.minecraft.birch_leaves": "Bjirkeblêden",
  "block.minecraft.birch_log": "Bjirkestam",
  "block.minecraft.birch_planks": "Bjirkehouten planken",
  "block.minecraft.birch_pressure_plate": "Bjirkehouten drukplaat",
  "block.minecraft.birch_sapling": "Bjirkekymplant",
  "block.minecraft.birch_shelf": "Birch Shelf",
  "block.minecraft.birch_sign": "Bjirkehouten boerd",
  "block.minecraft.birch_slab": "Bjirkehouten plaat",
  "block.minecraft.birch_stairs": "Bakstiennen trep",
  "block.minecraft.birch_trapdoor": "Bjirkehouten fallûk",
  "block.minecraft.birch_wall_hanging_sign": "Bjirkehouten úthingboerd",
  "block.minecraft.birch_wall_sign": "Bjirkehouten muorreboerd",
  "block.minecraft.birch_wood": "Bjirkehout",
  "block.minecraft.black_banner": "Swarte banier",
  "block.minecraft.black_bed": "Swart bêd",
  "block.minecraft.black_candle": "Swarte kears",
  "block.minecraft.black_candle_cake": "Taart mei in swarte kears",
  "block.minecraft.black_carpet": "Swart tapyt",
  "block.minecraft.black_concrete": "Swart beton",
  "block.minecraft.black_concrete_powder": "Swart semint",
  "block.minecraft.black_glazed_terracotta": "Swart glazuere terrakotta",
  "block.minecraft.black_shulker_box": "Swarte Shulker-doaze",
  "block.minecraft.black_stained_glass": "Swart kleurd glês",
  "block.minecraft.black_stained_glass_pane": "Swart kleurd glês",
  "block.minecraft.black_terracotta": "Swarte terrakotta",
  "block.minecraft.black_wool": "Swarte wol",
  "block.minecraft.blackstone": "Swartstien",
  "block.minecraft.blackstone_slab": "Swartstiennen plaat",
  "block.minecraft.blackstone_stairs": "Swartstiennen trep",
  "block.minecraft.blackstone_wall": "Swartstiennen muorre",
  "block.minecraft.blast_furnace": "Heechoven",
  "block.minecraft.blue_banner": "Blauwe banier",
  "block.minecraft.blue_bed": "Blau bêd",
  "block.minecraft.blue_candle": "Blauwe kears",
  "block.minecraft.blue_candle_cake": "Taart mei in blauwe kears",
  "block.minecraft.blue_carpet": "Blau tapyt",
  "block.minecraft.blue_concrete": "Blau beton",
  "block.minecraft.blue_concrete_powder": "Blau semint",
  "block.minecraft.blue_glazed_terracotta": "Blau glazuere terrakotta",
  "block.minecraft.blue_ice": "Blau iis",
  "block.minecraft.blue_orchid": "Blauwe orchidee",
  "block.minecraft.blue_shulker_box": "Blauwe Shulker-doaze",
  "block.minecraft.blue_stained_glass": "Blau kleurd glês",
  "block.minecraft.blue_stained_glass_pane": "Blau kleurd glês",
  "block.minecraft.blue_terracotta": "Blauwe terrakotta",
  "block.minecraft.blue_wool": "Blauwe wol",
  "block.minecraft.bone_block": "Bonkeblok",
  "block.minecraft.bookshelf": "Boekekast",
  "block.minecraft.brain_coral": "Harsenskoraal",
  "block.minecraft.brain_coral_block": "Harsenskoraalblok",
  "block.minecraft.brain_coral_fan": "Harsensgorgoon",
  "block.minecraft.brain_coral_wall_fan": "Harsenskoraalwaaier oan muorre",
  "block.minecraft.brewing_stand": "Broustandert",
  "block.minecraft.brick_slab": "Bakstiennen plaat",
  "block.minecraft.brick_stairs": "Bakstiennen trep",
  "block.minecraft.brick_wall": "Bakstiennen muorre",
  "block.minecraft.bricks": "Bakstiennen",
  "block.minecraft.brown_banner": "Brune banier",
  "block.minecraft.brown_bed": "Brún Bêd",
  "block.minecraft.brown_candle": "Brune kears",
  "block.minecraft.brown_candle_cake": "Taart mei in brune kears",
  "block.minecraft.brown_carpet": "Brún tapyt",
  "block.minecraft.brown_concrete": "Brún beton",
  "block.minecraft.brown_concrete_powder": "Brún semint",
  "block.minecraft.brown_glazed_terracotta": "Brún glazuere terrakotta",
  "block.minecraft.brown_mushroom": "Brune poddestoel",
  "block.minecraft.brown_mushroom_block": "Brune poddestuolleblok",
  "block.minecraft.brown_shulker_box": "Brune Shulker-doaze",
  "block.minecraft.brown_stained_glass": "Brún kleurd glês",
  "block.minecraft.brown_stained_glass_pane": "Brún kleurd glês",
  "block.minecraft.brown_terracotta": "Brune terrakotta",
  "block.minecraft.brown_wool": "Brune wol",
  "block.minecraft.bubble_column": "Bellenkolom",
  "block.minecraft.bubble_coral": "Blaaskoraal",
  "block.minecraft.bubble_coral_block": "Blaaskoraalblok",
  "block.minecraft.bubble_coral_fan": "Blaasgorgoon",
  "block.minecraft.bubble_coral_wall_fan": "Brobbelkoraalwaaier oan muorre",
  "block.minecraft.budding_amethyst": "Utrinnende ametist",
  "block.minecraft.bush": "Strûk",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Kaktusblom",
  "block.minecraft.cake": "Taart",
  "block.minecraft.calcite": "Calciet",
  "block.minecraft.calibrated_sculk_sensor": "Kalibrearre sculksensor",
  "block.minecraft.campfire": "Kampfjoer",
  "block.minecraft.candle": "Kears",
  "block.minecraft.candle_cake": "Taart mei in kears",
  "block.minecraft.carrots": "Woartels",
  "block.minecraft.cartography_table": "Kartografytafel",
  "block.minecraft.carved_pumpkin": "Bewurke pompoen",
  "block.minecraft.cauldron": "Tsjettel",
  "block.minecraft.cave_air": "Grotlucht",
  "block.minecraft.cave_vines": "Grotwynranken",
  "block.minecraft.cave_vines_plant": "Grotwynrankeplant",
  "block.minecraft.chain": "Ketting",
  "block.minecraft.chain_command_block": "Keppele opdrachtblok",
  "block.minecraft.cherry_button": "Kersehouten knop",
  "block.minecraft.cherry_door": "Kersehouten doar",
  "block.minecraft.cherry_fence": "Kersehouten stek",
  "block.minecraft.cherry_fence_gate": "Kersehouten stekpoarte",
  "block.minecraft.cherry_hanging_sign": "Kersehouten hingjend boerd",
  "block.minecraft.cherry_leaves": "Kerseblêden",
  "block.minecraft.cherry_log": "Kersehout",
  "block.minecraft.cherry_planks": "Kersehouten planken",
  "block.minecraft.cherry_pressure_plate": "Kersehouten drukplaat",
  "block.minecraft.cherry_sapling": "Kersesiedling",
  "block.minecraft.cherry_shelf": "Cherry Shelf",
  "block.minecraft.cherry_sign": "Kersehouten boerd",
  "block.minecraft.cherry_slab": "Kersehouten plaat",
  "block.minecraft.cherry_stairs": "Kersehouten trep",
  "block.minecraft.cherry_trapdoor": "Kersehouten fallûk",
  "block.minecraft.cherry_wall_hanging_sign": "Kersehouten úthingboerd",
  "block.minecraft.cherry_wall_sign": "Kersehouten muorreboerd",
  "block.minecraft.cherry_wood": "Kersehout",
  "block.minecraft.chest": "Kiste",
  "block.minecraft.chipped_anvil": "Barsten ambyld",
  "block.minecraft.chiseled_bookshelf": "Bewurke boekekast",
  "block.minecraft.chiseled_copper": "Bewurke koperblok",
  "block.minecraft.chiseled_deepslate": "Beitele laaistien",
  "block.minecraft.chiseled_nether_bricks": "Beitele Nether-bakstien",
  "block.minecraft.chiseled_polished_blackstone": "Beitele polyste swartstien",
  "block.minecraft.chiseled_quartz_block": "Beitele kwartsblok",
  "block.minecraft.chiseled_red_sandstone": "Beitele reade sânstien",
  "block.minecraft.chiseled_resin_bricks": "Chiseled Resin Bricks",
  "block.minecraft.chiseled_sandstone": "Beitele sânstien",
  "block.minecraft.chiseled_stone_bricks": "Bewurke blokstiennen",
  "block.minecraft.chiseled_tuff": "Beitele dowestien",
  "block.minecraft.chiseled_tuff_bricks": "Beitele dowestienblokstiennen",
  "block.minecraft.chorus_flower": "Koarblom",
  "block.minecraft.chorus_plant": "Koarplant",
  "block.minecraft.clay": "Klaai",
  "block.minecraft.closed_eyeblossom": "Closed Eyeblossom",
  "block.minecraft.coal_block": "Blok stienkoal",
  "block.minecraft.coal_ore": "Stienkoalerts",
  "block.minecraft.coarse_dirt": "Rûge ierde",
  "block.minecraft.cobbled_deepslate": "Oplate laaistien",
  "block.minecraft.cobbled_deepslate_slab": "Oplate laaistiennen plaat",
  "block.minecraft.cobbled_deepslate_stairs": "Oplate laaistiennen trep",
  "block.minecraft.cobbled_deepslate_wall": "Oplate laaistiennen muorre",
  "block.minecraft.cobblestone": "Balstien",
  "block.minecraft.cobblestone_slab": "Balstiennen plaat",
  "block.minecraft.cobblestone_stairs": "Balstiennen trep",
  "block.minecraft.cobblestone_wall": "Balstiennen muorre",
  "block.minecraft.cobweb": "Spinreach",
  "block.minecraft.cocoa": "Kakao",
  "block.minecraft.command_block": "Opdrachtblok",
  "block.minecraft.comparator": "Redstone-fergeliker",
  "block.minecraft.composter": "Kompostbult",
  "block.minecraft.conduit": "Krêft fan de see",
  "block.minecraft.copper_bars": "Copper Bars",
  "block.minecraft.copper_block": "Koperblok",
  "block.minecraft.copper_bulb": "Koperen lampe",
  "block.minecraft.copper_chain": "Copper Chain",
  "block.minecraft.copper_chest": "Koperen kiste",
  "block.minecraft.copper_door": "Koperen doar",
  "block.minecraft.copper_golem_statue": "Kopergolemstânbyld",
  "block.minecraft.copper_grate": "Koperen roaster",
  "block.minecraft.copper_lantern": "Copper Lantern",
  "block.minecraft.copper_ore": "Kopererts",
  "block.minecraft.copper_torch": "Copper Torch",
  "block.minecraft.copper_trapdoor": "Koperen fallûk",
  "block.minecraft.copper_wall_torch": "Copper Wall Torch",
  "block.minecraft.cornflower": "Roggeblom",
  "block.minecraft.cracked_deepslate_bricks": "Kreake laaistiennen bakstiennen",
  "block.minecraft.cracked_deepslate_tiles": "Kreake laaistiennen tegels",
  "block.minecraft.cracked_nether_bricks": "Kreake Nether-bakstien",
  "block.minecraft.cracked_polished_blackstone_bricks": "Beitele polyste swartstiennen bakstien",
  "block.minecraft.cracked_stone_bricks": "Barste blokstiennen",
  "block.minecraft.crafter": "Makker",
  "block.minecraft.crafting_table": "Wurkbank",
  "block.minecraft.creaking_heart": "Creaking Heart",
  "block.minecraft.creeper_head": "Creeper-kop",
  "block.minecraft.creeper_wall_head": "Creeperholle oan de muorre",
  "block.minecraft.crimson_button": "Helreade houten knop",
  "block.minecraft.crimson_door": "Helreade houten doar",
  "block.minecraft.crimson_fence": "Helreade houten hek",
  "block.minecraft.crimson_fence_gate": "Helreade houten poarte",
  "block.minecraft.crimson_fungus": "Helreade swam",
  "block.minecraft.crimson_hanging_sign": "Felread houten úthingboerd",
  "block.minecraft.crimson_hyphae": "Helreade skimmeltrieden",
  "block.minecraft.crimson_nylium": "Helread nylium",
  "block.minecraft.crimson_planks": "Helreade houten planken",
  "block.minecraft.crimson_pressure_plate": "Helreade houten drukplaat",
  "block.minecraft.crimson_roots": "Helreade woartels",
  "block.minecraft.crimson_shelf": "Crimson Shelf",
  "block.minecraft.crimson_sign": "Helreade houten boerd",
  "block.minecraft.crimson_slab": "Helreade houten plaat",
  "block.minecraft.crimson_stairs": "Helreade houten trep",
  "block.minecraft.crimson_stem": "Helreade stam",
  "block.minecraft.crimson_trapdoor": "Helreade houten fallûk",
  "block.minecraft.crimson_wall_hanging_sign": "Felread houten úthingboerd",
  "block.minecraft.crimson_wall_sign": "Helreade boerd oan muorre",
  "block.minecraft.crying_obsidian": "Gûlende Obsidiaan",
  "block.minecraft.cut_copper": "Snijde koperblok",
  "block.minecraft.cut_copper_slab": "Snijde koperen plaat",
  "block.minecraft.cut_copper_stairs": "Snijd koperen trep",
  "block.minecraft.cut_red_sandstone": "Sneden read sânstien",
  "block.minecraft.cut_red_sandstone_slab": "Sneden reade sânstiennen plaat",
  "block.minecraft.cut_sandstone": "Sneden sânstien",
  "block.minecraft.cut_sandstone_slab": "Sneden sânstiennen plaat",
  "block.minecraft.cyan_banner": "Turkoaiske banier",
  "block.minecraft.cyan_bed": "Turkoaiske bêd",
  "block.minecraft.cyan_candle": "Turkoaiske kears",
  "block.minecraft.cyan_candle_cake": "Taart mei in syane kears",
  "block.minecraft.cyan_carpet": "Turkoaiske tapyt",
  "block.minecraft.cyan_concrete": "Turkoaiske beton",
  "block.minecraft.cyan_concrete_powder": "Turkoaiske semint",
  "block.minecraft.cyan_glazed_terracotta": "Turkoaiske glazuere terrakotta",
  "block.minecraft.cyan_shulker_box": "Turkoaiske Shulker-doaze",
  "block.minecraft.cyan_stained_glass": "Turkoaiske kleurd glês",
  "block.minecraft.cyan_stained_glass_pane": "Turkoaiske kleurd glês",
  "block.minecraft.cyan_terracotta": "Turkoaiske terrakotta",
  "block.minecraft.cyan_wool": "Turkoaiske wol",
  "block.minecraft.damaged_anvil": "Skansearre ambyld",
  "block.minecraft.dandelion": "Hynsteblom",
  "block.minecraft.dark_oak_button": "Donker ikehouten knop",
  "block.minecraft.dark_oak_door": "Donkere ikehouten doar",
  "block.minecraft.dark_oak_fence": "Donkere ikehouten stek",
  "block.minecraft.dark_oak_fence_gate": "Donkere ikehouten stekpoartsje",
  "block.minecraft.dark_oak_hanging_sign": "Donker ikehouten úthingboerd",
  "block.minecraft.dark_oak_leaves": "Donkere ikeblêden",
  "block.minecraft.dark_oak_log": "Donkere ikestam",
  "block.minecraft.dark_oak_planks": "Donkere ikehouten planken",
  "block.minecraft.dark_oak_pressure_plate": "Donker ikehouten drukplaat",
  "block.minecraft.dark_oak_sapling": "Donkere ikekymplant",
  "block.minecraft.dark_oak_shelf": "Dark Oak Shelf",
  "block.minecraft.dark_oak_sign": "Donker ikehouten boerd",
  "block.minecraft.dark_oak_slab": "Donkere ikehouten plaat",
  "block.minecraft.dark_oak_stairs": "Donker ikehouten trep",
  "block.minecraft.dark_oak_trapdoor": "Donker ikehouten fallûk",
  "block.minecraft.dark_oak_wall_hanging_sign": "Donker ikehouten úthingboerd",
  "block.minecraft.dark_oak_wall_sign": "Donkerikehouten muorreboerd",
  "block.minecraft.dark_oak_wood": "Donker ikehout",
  "block.minecraft.dark_prismarine": "Donkere prismarine",
  "block.minecraft.dark_prismarine_slab": "Donkere prismarine plaat",
  "block.minecraft.dark_prismarine_stairs": "Donkere prismarine trep",
  "block.minecraft.daylight_detector": "Deiljochtsensor",
  "block.minecraft.dead_brain_coral": "Dea harsenskoraal",
  "block.minecraft.dead_brain_coral_block": "Dea harsenskoraalblok",
  "block.minecraft.dead_brain_coral_fan": "Dea harsenskoraalwaaier",
  "block.minecraft.dead_brain_coral_wall_fan": "Dea harsenskoraalwaaier oan muorre",
  "block.minecraft.dead_bubble_coral": "Dea brobbelkoraal",
  "block.minecraft.dead_bubble_coral_block": "Dea blaaskoraalblok",
  "block.minecraft.dead_bubble_coral_fan": "Dea brobbelkoraalwaaier",
  "block.minecraft.dead_bubble_coral_wall_fan": "Dea brobbelkoraalwaaier oan muorre",
  "block.minecraft.dead_bush": "Deade strûk",
  "block.minecraft.dead_fire_coral": "Dea fjoerkoraal",
  "block.minecraft.dead_fire_coral_block": "Dea brânkoraalblok",
  "block.minecraft.dead_fire_coral_fan": "Dea fjoerkoraalwaaier",
  "block.minecraft.dead_fire_coral_wall_fan": "Dea fjoerkoraalwaaier oan muorre",
  "block.minecraft.dead_horn_coral": "Dea hoarnkoraal",
  "block.minecraft.dead_horn_coral_block": "Dea hoarnkoraalblok",
  "block.minecraft.dead_horn_coral_fan": "Dea hoarnkoraalwaaier",
  "block.minecraft.dead_horn_coral_wall_fan": "Dea hoarnkoraalwaaier oan muorre",
  "block.minecraft.dead_tube_coral": "Dea buiskoraal",
  "block.minecraft.dead_tube_coral_block": "Dea buiskoraalblok",
  "block.minecraft.dead_tube_coral_fan": "Dea buiskoraalwaaier",
  "block.minecraft.dead_tube_coral_wall_fan": "Dea buiskoraalwaaier oan muorre",
  "block.minecraft.decorated_pot": "Fersierde pot",
  "block.minecraft.deepslate": "Laaistien",
  "block.minecraft.deepslate_brick_slab": "Laaistiennen plaat",
  "block.minecraft.deepslate_brick_stairs": "Laaistiennen trep",
  "block.minecraft.deepslate_brick_wall": "Laaistiennen muorre",
  "block.minecraft.deepslate_bricks": "Laaistiennen",
  "block.minecraft.deepslate_coal_ore": "Laaistien-stienkoalerts",
  "block.minecraft.deepslate_copper_ore": "Laaistienkopererts",
  "block.minecraft.deepslate_diamond_ore": "Laaistiendiamanterts",
  "block.minecraft.deepslate_emerald_ore": "Laaistiensmaragderts",
  "block.minecraft.deepslate_gold_ore": "Laaistien gouden erts",
  "block.minecraft.deepslate_iron_ore": "Laaistienizererts",
  "block.minecraft.deepslate_lapis_ore": "Laaistienapislazuli-erts",
  "block.minecraft.deepslate_redstone_ore": "Laaistienredstone-erts",
  "block.minecraft.deepslate_tile_slab": "Laaistiennen tegelplaat",
  "block.minecraft.deepslate_tile_stairs": "Laaistiennen tegeltrep",
  "block.minecraft.deepslate_tile_wall": "Laaistiennen tegelmuorre",
  "block.minecraft.deepslate_tiles": "Laaistiennen tegels",
  "block.minecraft.detector_rail": "Deteksjespoar",
  "block.minecraft.diamond_block": "Diamantblok",
  "block.minecraft.diamond_ore": "Diamanterts",
  "block.minecraft.diorite": "Dioryt",
  "block.minecraft.diorite_slab": "Dioriten plaat",
  "block.minecraft.diorite_stairs": "Dioriten rep",
  "block.minecraft.diorite_wall": "Diorytmuorre",
  "block.minecraft.dirt": "Ierde",
  "block.minecraft.dirt_path": "Modderpaad",
  "block.minecraft.dispenser": "Smiter",
  "block.minecraft.dragon_egg": "Drake-aai",
  "block.minecraft.dragon_head": "Drakekop",
  "block.minecraft.dragon_wall_head": "Drakeholle oan muorre",
  "block.minecraft.dried_ghast": "Dried Ghast",
  "block.minecraft.dried_kelp_block": "Drûge kelpblok",
  "block.minecraft.dripstone_block": "Dripstienblok",
  "block.minecraft.dropper": "Jouwer",
  "block.minecraft.emerald_block": "Smaragdblok",
  "block.minecraft.emerald_ore": "Smaragderts",
  "block.minecraft.enchanting_table": "Betsjoeningstafel",
  "block.minecraft.end_gateway": "Endportaal",
  "block.minecraft.end_portal": "End-portaal",
  "block.minecraft.end_portal_frame": "Endportaalframe",
  "block.minecraft.end_rod": "End-stêf",
  "block.minecraft.end_stone": "End-stien",
  "block.minecraft.end_stone_brick_slab": "Einblokstiennen plaat",
  "block.minecraft.end_stone_brick_stairs": "Einblokstiennen trep",
  "block.minecraft.end_stone_brick_wall": "Einblokstiennen muorre",
  "block.minecraft.end_stone_bricks": "End-houstiennen",
  "block.minecraft.ender_chest": "Ender-kiste",
  "block.minecraft.exposed_chiseled_copper": "Bleatsteld bewurke koperblok",
  "block.minecraft.exposed_copper": "Bleatsteld koperblok",
  "block.minecraft.exposed_copper_bars": "Exposed Copper Bars",
  "block.minecraft.exposed_copper_bulb": "Bleatstelde koperen lampe",
  "block.minecraft.exposed_copper_chain": "Exposed Copper Chain",
  "block.minecraft.exposed_copper_chest": "Exposed Copper Chest",
  "block.minecraft.exposed_copper_door": "Bleatstelde koperen doar",
  "block.minecraft.exposed_copper_golem_statue": "Bleatsteld kopergolemstânbyld",
  "block.minecraft.exposed_copper_grate": "Bleatstelde koperen roaster",
  "block.minecraft.exposed_copper_lantern": "Exposed Copper Lantern",
  "block.minecraft.exposed_copper_trapdoor": "Bleatstelde koperen fallûk",
  "block.minecraft.exposed_cut_copper": "Bleatsteld snijd koperblok",
  "block.minecraft.exposed_cut_copper_slab": "Bleatsteld snijd koperen plaat",
  "block.minecraft.exposed_cut_copper_stairs": "Bleatsteld snijd koperen trep",
  "block.minecraft.exposed_lightning_rod": "Exposed Lightning Rod",
  "block.minecraft.farmland": "Boulân",
  "block.minecraft.fern": "Faren",
  "block.minecraft.fire": "Fjoer",
  "block.minecraft.fire_coral": "Brânkoraal",
  "block.minecraft.fire_coral_block": "Brânkoraalblok",
  "block.minecraft.fire_coral_fan": "Brângorgoon",
  "block.minecraft.fire_coral_wall_fan": "Fjoerkoraalwaaier oan muorre",
  "block.minecraft.firefly_bush": "Firefly Bush",
  "block.minecraft.fletching_table": "Bewapeningstafel",
  "block.minecraft.flower_pot": "Blompot",
  "block.minecraft.flowering_azalea": "Bloeiende asalea",
  "block.minecraft.flowering_azalea_leaves": "Bloeiende asaleablêden",
  "block.minecraft.frogspawn": "Kikkertdril",
  "block.minecraft.frosted_ice": "Beripe iis",
  "block.minecraft.furnace": "Oven",
  "block.minecraft.gilded_blackstone": "Fergulde swartstien",
  "block.minecraft.glass": "Glês",
  "block.minecraft.glass_pane": "Glêzen rút",
  "block.minecraft.glow_lichen": "Gloeiend koarstmoas",
  "block.minecraft.glowstone": "Gleonstien",
  "block.minecraft.gold_block": "Blok goud",
  "block.minecraft.gold_ore": "Gouderts",
  "block.minecraft.golden_dandelion": "Golden Dandelion",
  "block.minecraft.granite": "Granyt",
  "block.minecraft.granite_slab": "Graniten plaat",
  "block.minecraft.granite_stairs": "Graniten trep",
  "block.minecraft.granite_wall": "Graniten muorre",
  "block.minecraft.grass": "Gers",
  "block.minecraft.grass_block": "Blok gers",
  "block.minecraft.gravel": "Gryn",
  "block.minecraft.gray_banner": "Grize banier",
  "block.minecraft.gray_bed": "Griis bêd",
  "block.minecraft.gray_candle": "Grize kears",
  "block.minecraft.gray_candle_cake": "Taart mei in grize kears",
  "block.minecraft.gray_carpet": "Griis tapyt",
  "block.minecraft.gray_concrete": "Griis beton",
  "block.minecraft.gray_concrete_powder": "Griis semint",
  "block.minecraft.gray_glazed_terracotta": "Griis glazuere terrakotta",
  "block.minecraft.gray_shulker_box": "Grize Shulker-doaze",
  "block.minecraft.gray_stained_glass": "Griis kleurd glês",
  "block.minecraft.gray_stained_glass_pane": "Griis kleurd glês",
  "block.minecraft.gray_terracotta": "Grize terrakotta",
  "block.minecraft.gray_wool": "Grize wol",
  "block.minecraft.green_banner": "Griene banier",
  "block.minecraft.green_bed": "Grien bêd",
  "block.minecraft.green_candle": "Griene kears",
  "block.minecraft.green_candle_cake": "Taart mei in griene kears",
  "block.minecraft.green_carpet": "Grien tapyt",
  "block.minecraft.green_concrete": "Grien beton",
  "block.minecraft.green_concrete_powder": "Grien semint",
  "block.minecraft.green_glazed_terracotta": "Grien glazuere terrakotta",
  "block.minecraft.green_shulker_box": "Griene Shulker-doaze",
  "block.minecraft.green_stained_glass": "Grien kleurd glês",
  "block.minecraft.green_stained_glass_pane": "Grien kleurd glês",
  "block.minecraft.green_terracotta": "Griene terrakotta",
  "block.minecraft.green_wool": "Griene wol",
  "block.minecraft.grindstone": "Slypstien",
  "block.minecraft.hanging_roots": "Hingjende woartels",
  "block.minecraft.hay_block": "Klobbe hea",
  "block.minecraft.heavy_core": "Heavy Core",
  "block.minecraft.heavy_weighted_pressure_plate": "Swiergefoelige drukplaat",
  "block.minecraft.honey_block": "Huningblok",
  "block.minecraft.honeycomb_block": "Huningraatblok",
  "block.minecraft.hopper": "Trachter",
  "block.minecraft.horn_coral": "Hoarnkoraal",
  "block.minecraft.horn_coral_block": "Hoarnkoraalblok",
  "block.minecraft.horn_coral_fan": "Hoarngorgoon",
  "block.minecraft.horn_coral_wall_fan": "Hoarnkoraalwaaier oan muorre",
  "block.minecraft.ice": "Iis",
  "block.minecraft.infested_chiseled_stone_bricks": "Ynfektearre slepen blokstiennen",
  "block.minecraft.infested_cobblestone": "Ynfektearre keistien",
  "block.minecraft.infested_cracked_stone_bricks": "Ynfektearre barsten blokstiennen",
  "block.minecraft.infested_deepslate": "Besmet laaistien",
  "block.minecraft.infested_mossy_stone_bricks": "Ynfektearre moassige blokstienen",
  "block.minecraft.infested_stone": "Ynfektearre stien",
  "block.minecraft.infested_stone_bricks": "Ynfektearre blokstiennen",
  "block.minecraft.iron_bars": "Izeren traaljes",
  "block.minecraft.iron_block": "Blok izer",
  "block.minecraft.iron_chain": "Izeren ketting",
  "block.minecraft.iron_door": "Izeren doar",
  "block.minecraft.iron_ore": "Izererts",
  "block.minecraft.iron_trapdoor": "Izeren fallûk",
  "block.minecraft.jack_o_lantern": "Jack o'Lantern",
  "block.minecraft.jigsaw": "Puzelblok",
  "block.minecraft.jukebox": "Jukebox",
  "block.minecraft.jungle_button": "Oerwâldhouten knop",
  "block.minecraft.jungle_door": "Oerwâldhouten doar",
  "block.minecraft.jungle_fence": "Oerwâldhouten stek",
  "block.minecraft.jungle_fence_gate": "Oerwâldhouten stekpoartsje",
  "block.minecraft.jungle_hanging_sign": "Oerwâldhouten úthingboerd",
  "block.minecraft.jungle_leaves": "Oerwâldblêden",
  "block.minecraft.jungle_log": "Oerwâldstam",
  "block.minecraft.jungle_planks": "Oerwâldhouten planken",
  "block.minecraft.jungle_pressure_plate": "Oerwâldhouten drukplaat",
  "block.minecraft.jungle_sapling": "Oerwâldkymplant",
  "block.minecraft.jungle_shelf": "Jungle Shelf",
  "block.minecraft.jungle_sign": "Oerwâldhouten boerd",
  "block.minecraft.jungle_slab": "Oerwâldhouten plaat",
  "block.minecraft.jungle_stairs": "Oerwâldhouten trep",
  "block.minecraft.jungle_trapdoor": "Oerwâldhouten fallûk",
  "block.minecraft.jungle_wall_hanging_sign": "Oerwâldhouten úthingboerd",
  "block.minecraft.jungle_wall_sign": "Oerwâldhouten muorreboerd",
  "block.minecraft.jungle_wood": "Oerwâldhout",
  "block.minecraft.kelp": "Kelp",
  "block.minecraft.kelp_plant": "Kelpplant",
  "block.minecraft.ladder": "Ljedder",
  "block.minecraft.lantern": "Lantearne",
  "block.minecraft.lapis_block": "Lapislazuliblok",
  "block.minecraft.lapis_ore": "Lapis lazuli-erts",
  "block.minecraft.large_amethyst_bud": "Grutte ametistknop",
  "block.minecraft.large_fern": "Grutte faren",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Tsjettel mei lava",
  "block.minecraft.leaf_litter": "Leaf Litter",
  "block.minecraft.lectern": "Lessener",
  "block.minecraft.lever": "Hânsel",
  "block.minecraft.light": "Ljocht",
  "block.minecraft.light_blue_banner": "Ljochtblauwe banier",
  "block.minecraft.light_blue_bed": "Ljochtblau bêd",
  "block.minecraft.light_blue_candle": "Ljochtblauwe kears",
  "block.minecraft.light_blue_candle_cake": "Taart mei in ljochtblauwe kears",
  "block.minecraft.light_blue_carpet": "Ljochtblau tapyt",
  "block.minecraft.light_blue_concrete": "Ljochtblau beton",
  "block.minecraft.light_blue_concrete_powder": "Ljochtblau semint",
  "block.minecraft.light_blue_glazed_terracotta": "Ljochtblau glazuere terrakotta",
  "block.minecraft.light_blue_shulker_box": "Ljochtblauwe Shulker-doaze",
  "block.minecraft.light_blue_stained_glass": "Ljochtblau kleurd glês",
  "block.minecraft.light_blue_stained_glass_pane": "Ljochtblau kleurd glês",
  "block.minecraft.light_blue_terracotta": "Ljochtblauwe terrakotta",
  "block.minecraft.light_blue_wool": "Ljochtblauwe wol",
  "block.minecraft.light_gray_banner": "Ljochtgrize banier",
  "block.minecraft.light_gray_bed": "Ljocht griis bêd",
  "block.minecraft.light_gray_candle": "Ljochtgrize kears",
  "block.minecraft.light_gray_candle_cake": "Taart mei in ljochtgrize kears",
  "block.minecraft.light_gray_carpet": "Ljochtgriis tapyt",
  "block.minecraft.light_gray_concrete": "Ljochtgriis beton",
  "block.minecraft.light_gray_concrete_powder": "Ljochtgriis semint",
  "block.minecraft.light_gray_glazed_terracotta": "Ljochtgriis glazuere terrakotta",
  "block.minecraft.light_gray_shulker_box": "Ljochtgrize Shulker-doaze",
  "block.minecraft.light_gray_stained_glass": "Ljochtgriis kleurd glês",
  "block.minecraft.light_gray_stained_glass_pane": "Ljochtgriis kleurd glês",
  "block.minecraft.light_gray_terracotta": "Ljochtgrize terrakotta",
  "block.minecraft.light_gray_wool": "Ljochtgrize wol",
  "block.minecraft.light_weighted_pressure_plate": "Ljochtgefoelige drukplaat",
  "block.minecraft.lightning_rod": "Tongerlieder",
  "block.minecraft.lilac": "Sering",
  "block.minecraft.lily_of_the_valley": "Maaieklokje",
  "block.minecraft.lily_pad": "Pompeblêd",
  "block.minecraft.lime_banner": "Ljochtgriene banier",
  "block.minecraft.lime_bed": "Ljochtgrien bêd",
  "block.minecraft.lime_candle": "Ljochtgriene kears",
  "block.minecraft.lime_candle_cake": "Taart mei in ljochtgriene kears",
  "block.minecraft.lime_carpet": "Ljochtgrien tapyt",
  "block.minecraft.lime_concrete": "Ljochtgrien beton",
  "block.minecraft.lime_concrete_powder": "Ljochtgrien semint",
  "block.minecraft.lime_glazed_terracotta": "Ljochtgrien glazuere terrakotta",
  "block.minecraft.lime_shulker_box": "Ljochtgriene Shulker-doaze",
  "block.minecraft.lime_stained_glass": "Ljochtgrien kleurd glês",
  "block.minecraft.lime_stained_glass_pane": "Ljochtgrien kleurd glês",
  "block.minecraft.lime_terracotta": "Ljochtgriene terrakotta",
  "block.minecraft.lime_wool": "Ljochtgriene wol",
  "block.minecraft.lodestone": "Seilstien",
  "block.minecraft.loom": "Weeftou",
  "block.minecraft.magenta_banner": "Maginta banier",
  "block.minecraft.magenta_bed": "Maginta bêd",
  "block.minecraft.magenta_candle": "Maginta kears",
  "block.minecraft.magenta_candle_cake": "Taart mei in maginta kears",
  "block.minecraft.magenta_carpet": "Maginta tapyt",
  "block.minecraft.magenta_concrete": "Maginta beton",
  "block.minecraft.magenta_concrete_powder": "Maginta semint",
  "block.minecraft.magenta_glazed_terracotta": "Maginta glazuere terrakotta",
  "block.minecraft.magenta_shulker_box": "Maginta Shulker-doaze",
  "block.minecraft.magenta_stained_glass": "Maginta kleurd glês",
  "block.minecraft.magenta_stained_glass_pane": "Maginta kleurd glês",
  "block.minecraft.magenta_terracotta": "Maginta terrakotta",
  "block.minecraft.magenta_wool": "Maginta wol",
  "block.minecraft.magma_block": "Magmablok",
  "block.minecraft.mangrove_button": "Mangrovehouten knop",
  "block.minecraft.mangrove_door": "Mangrovehouten doar",
  "block.minecraft.mangrove_fence": "Mangrovehouten stek",
  "block.minecraft.mangrove_fence_gate": "Mangrovehouten poarte",
  "block.minecraft.mangrove_hanging_sign": "Mangrovehouten úthangbord",
  "block.minecraft.mangrove_leaves": "Mangroveblêden",
  "block.minecraft.mangrove_log": "Mangrovestam",
  "block.minecraft.mangrove_planks": "Mangrovehouten planken",
  "block.minecraft.mangrove_pressure_plate": "Mangrovehouten drukplaat",
  "block.minecraft.mangrove_propagule": "Mangrovebroedknop",
  "block.minecraft.mangrove_roots": "Mangrovewoartels",
  "block.minecraft.mangrove_shelf": "Mangrove Shelf",
  "block.minecraft.mangrove_sign": "Mangrovehouten board",
  "block.minecraft.mangrove_slab": "Mangrovehouten plaat",
  "block.minecraft.mangrove_stairs": "Mangrovehouten trep",
  "block.minecraft.mangrove_trapdoor": "Mangrovehouten fallûk",
  "block.minecraft.mangrove_wall_hanging_sign": "Mangrovehouten úthangbord",
  "block.minecraft.mangrove_wall_sign": "Mangrovehouten boerd oan muorre",
  "block.minecraft.mangrove_wood": "Mangrovehout",
  "block.minecraft.medium_amethyst_bud": "Medium ametistknop",
  "block.minecraft.melon": "Wettermeloen",
  "block.minecraft.melon_stem": "Meloenstam",
  "block.minecraft.moss_block": "Moasblok",
  "block.minecraft.moss_carpet": "Moastapyt",
  "block.minecraft.mossy_cobblestone": "Moassige balstiennen",
  "block.minecraft.mossy_cobblestone_slab": "Moassich keistiennen plaat",
  "block.minecraft.mossy_cobblestone_stairs": "Moassich keistiennen trep",
  "block.minecraft.mossy_cobblestone_wall": "Moassige balstiennen muorre",
  "block.minecraft.mossy_stone_brick_slab": "Moassich blokstiennen plaat",
  "block.minecraft.mossy_stone_brick_stairs": "Moassich blokstiennen trep",
  "block.minecraft.mossy_stone_brick_wall": "Moassich blokstiennen muorre",
  "block.minecraft.mossy_stone_bricks": "Moassige blokstiennen",
  "block.minecraft.moving_piston": "Bewegende sûger",
  "block.minecraft.mud": "Modder",
  "block.minecraft.mud_brick_slab": "Modderstiennen plaat",
  "block.minecraft.mud_brick_stairs": "Modderstiennen trep",
  "block.minecraft.mud_brick_wall": "Modderstiennen muorre",
  "block.minecraft.mud_bricks": "Modderstiennen",
  "block.minecraft.muddy_mangrove_roots": "Modderige mangrovewoartels",
  "block.minecraft.mushroom_stem": "Poddestuollensnuorrepot",
  "block.minecraft.mycelium": "Swamflok",
  "block.minecraft.nether_brick_fence": "Nether-bakstiennen stek",
  "block.minecraft.nether_brick_slab": "Netherbakstiennen plaat",
  "block.minecraft.nether_brick_stairs": "Nether-bakstiennen trêden",
  "block.minecraft.nether_brick_wall": "Netherbakstiennen muorre",
  "block.minecraft.nether_bricks": "Netherbakstiennen",
  "block.minecraft.nether_gold_ore": "Nethergoudenerts",
  "block.minecraft.nether_portal": "Netherportaal",
  "block.minecraft.nether_quartz_ore": "Nether-kwartserts",
  "block.minecraft.nether_sprouts": "Nethersprútsjes",
  "block.minecraft.nether_wart": "Nether-krûd",
  "block.minecraft.nether_wart_block": "Nether-krûdblok",
  "block.minecraft.netherite_block": "Netherietblok",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Noateblok",
  "block.minecraft.oak_button": "Ikehouten knop",
  "block.minecraft.oak_door": "Ikehouten doar",
  "block.minecraft.oak_fence": "Ikehouten stek",
  "block.minecraft.oak_fence_gate": "Ikehouten stekpoartsje",
  "block.minecraft.oak_hanging_sign": "Ikehouten úthingboerd",
  "block.minecraft.oak_leaves": "Ikeblêden",
  "block.minecraft.oak_log": "Ikestam",
  "block.minecraft.oak_planks": "Ikehouten planken",
  "block.minecraft.oak_pressure_plate": "Ikehouten drukplaat",
  "block.minecraft.oak_sapling": "Ikekymplant",
  "block.minecraft.oak_shelf": "Oak Shelf",
  "block.minecraft.oak_sign": "Ikehouten boerd",
  "block.minecraft.oak_slab": "Ikehouten plaat",
  "block.minecraft.oak_stairs": "Ikehouten trep",
  "block.minecraft.oak_trapdoor": "Ikehouten fallûk",
  "block.minecraft.oak_wall_hanging_sign": "Ikehouten úthingboerd",
  "block.minecraft.oak_wall_sign": "Ikehouten muorreboerd",
  "block.minecraft.oak_wood": "Ikehout",
  "block.minecraft.observer": "Observearder",
  "block.minecraft.obsidian": "Obsidiaan",
  "block.minecraft.ochre_froglight": "Okergiel kikkertljocht",
  "block.minecraft.ominous_banner": "Driigjende flagge",
  "block.minecraft.open_eyeblossom": "Open Eyeblossom",
  "block.minecraft.orange_banner": "Oranje banier",
  "block.minecraft.orange_bed": "Oranje bêd",
  "block.minecraft.orange_candle": "Oranje kears",
  "block.minecraft.orange_candle_cake": "Taart mei in oranje kears",
  "block.minecraft.orange_carpet": "Oranje tapyt",
  "block.minecraft.orange_concrete": "Oranje beton",
  "block.minecraft.orange_concrete_powder": "Oranje semint",
  "block.minecraft.orange_glazed_terracotta": "Oranje glazuere terrakotta",
  "block.minecraft.orange_shulker_box": "Oranje Shulker-doaze",
  "block.minecraft.orange_stained_glass": "Oranje kleurd glês",
  "block.minecraft.orange_stained_glass_pane": "Oranje kleurd glês",
  "block.minecraft.orange_terracotta": "Oranje terrakotta",
  "block.minecraft.orange_tulip": "Oranje tulp",
  "block.minecraft.orange_wool": "Oranje wol",
  "block.minecraft.oxeye_daisy": "Guozzeblom",
  "block.minecraft.oxidized_chiseled_copper": "Oksidearre bewurke koperblok",
  "block.minecraft.oxidized_copper": "Oksidearre koperblok",
  "block.minecraft.oxidized_copper_bars": "Oxidized Copper Bars",
  "block.minecraft.oxidized_copper_bulb": "Oksidearre koperen lampe",
  "block.minecraft.oxidized_copper_chain": "Oxidized Copper Chain",
  "block.minecraft.oxidized_copper_chest": "Oxidized Copper Chest",
  "block.minecraft.oxidized_copper_door": "Oksidearre koperen doar",
  "block.minecraft.oxidized_copper_golem_statue": "Oksidearre kopergolemstânbyld",
  "block.minecraft.oxidized_copper_grate": "Oksidearre koperen roaster",
  "block.minecraft.oxidized_copper_lantern": "Oxidized Copper Lantern",
  "block.minecraft.oxidized_copper_trapdoor": "Oksidearre koperen fallûk",
  "block.minecraft.oxidized_cut_copper": "Oksidearre snijd koperblok",
  "block.minecraft.oxidized_cut_copper_slab": "Oksidearre snijde koperen plaat",
  "block.minecraft.oxidized_cut_copper_stairs": "Oksidearre snijde koperen trep",
  "block.minecraft.oxidized_lightning_rod": "Oxidized Lightning Rod",
  "block.minecraft.packed_ice": "Pakiis",
  "block.minecraft.packed_mud": "Pakmodder",
  "block.minecraft.pale_hanging_moss": "Pale Hanging Moss",
  "block.minecraft.pale_moss_block": "Pale Moss Block",
  "block.minecraft.pale_moss_carpet": "Pale Moss Carpet",
  "block.minecraft.pale_oak_button": "Pale Oak Button",
  "block.minecraft.pale_oak_door": "Pale Oak Door",
  "block.minecraft.pale_oak_fence": "Pale Oak Fence",
  "block.minecraft.pale_oak_fence_gate": "Pale Oak Fence Gate",
  "block.minecraft.pale_oak_hanging_sign": "Pale Oak Hanging Sign",
  "block.minecraft.pale_oak_leaves": "Pale Oak Leaves",
  "block.minecraft.pale_oak_log": "Pale Oak Log",
  "block.minecraft.pale_oak_planks": "Pale Oak Planks",
  "block.minecraft.pale_oak_pressure_plate": "Pale Oak Pressure Plate",
  "block.minecraft.pale_oak_sapling": "Pale Oak Sapling",
  "block.minecraft.pale_oak_shelf": "Pale Oak Shelf",
  "block.minecraft.pale_oak_sign": "Pale Oak Sign",
  "block.minecraft.pale_oak_slab": "Pale Oak Slab",
  "block.minecraft.pale_oak_stairs": "Pale Oak Stairs",
  "block.minecraft.pale_oak_trapdoor": "Pale Oak Trapdoor",
  "block.minecraft.pale_oak_wall_hanging_sign": "Pale Oak Wall Hanging Sign",
  "block.minecraft.pale_oak_wall_sign": "Pale Oak Wall Sign",
  "block.minecraft.pale_oak_wood": "Pale Oak Wood",
  "block.minecraft.pearlescent_froglight": "Pears kikkertljocht",
  "block.minecraft.peony": "Pioenroas",
  "block.minecraft.petrified_oak_slab": "Ferstiene ikehouten plaat",
  "block.minecraft.piglin_head": "Piglinholle",
  "block.minecraft.piglin_wall_head": "Piglinholle oan muorre",
  "block.minecraft.pink_banner": "Rôze banier",
  "block.minecraft.pink_bed": "Rose bêd",
  "block.minecraft.pink_candle": "Rôze kears",
  "block.minecraft.pink_candle_cake": "Taart mei in rôze kears",
  "block.minecraft.pink_carpet": "Rôze tapyt",
  "block.minecraft.pink_concrete": "Rôze beton",
  "block.minecraft.pink_concrete_powder": "Rôze semint",
  "block.minecraft.pink_glazed_terracotta": "Rôze glazuere terrakotta",
  "block.minecraft.pink_petals": "Rôze blombledsjes",
  "block.minecraft.pink_shulker_box": "Rôze Shulker-doaze",
  "block.minecraft.pink_stained_glass": "Rôze kleurd glês",
  "block.minecraft.pink_stained_glass_pane": "Rôze kleurd glês",
  "block.minecraft.pink_terracotta": "Rôze terrakotta",
  "block.minecraft.pink_tulip": "Rôze tulp",
  "block.minecraft.pink_wool": "Rôze wol",
  "block.minecraft.piston": "Sûger",
  "block.minecraft.piston_head": "Sûgerholle",
  "block.minecraft.pitcher_crop": "Bekerplantgewaaks",
  "block.minecraft.pitcher_plant": "Bekerplant",
  "block.minecraft.player_head": "Spilerholle",
  "block.minecraft.player_head.named": "Holle fan %s",
  "block.minecraft.player_wall_head": "Spilerholle oan muorre",
  "block.minecraft.podzol": "Podsol",
  "block.minecraft.pointed_dripstone": "Puntige dripstien",
  "block.minecraft.polished_andesite": "Polyste andesyt",
  "block.minecraft.polished_andesite_slab": "Polyste andesiten plaat",
  "block.minecraft.polished_andesite_stairs": "Polyste andesiten trep",
  "block.minecraft.polished_basalt": "Polyste basalt",
  "block.minecraft.polished_blackstone": "Polyste swartstien",
  "block.minecraft.polished_blackstone_brick_slab": "Polyste swartstiennen blokstiennen plaat",
  "block.minecraft.polished_blackstone_brick_stairs": "Polyste swartstiennen blokstiennen trep",
  "block.minecraft.polished_blackstone_brick_wall": "Polyste swartstiennen blokstiennen muorre",
  "block.minecraft.polished_blackstone_bricks": "Polyste swartstiennen blokstiennen",
  "block.minecraft.polished_blackstone_button": "Polyste swartstiennen knop",
  "block.minecraft.polished_blackstone_pressure_plate": "Polyste swartstiennen drukplaat",
  "block.minecraft.polished_blackstone_slab": "Polyste swartstiennen plaat",
  "block.minecraft.polished_blackstone_stairs": "Polyste swartstiennen treppen",
  "block.minecraft.polished_blackstone_wall": "Polyste swartstiennen muorre",
  "block.minecraft.polished_deepslate": "Polyste laaistien",
  "block.minecraft.polished_deepslate_slab": "Polyste laaistiennen plaat",
  "block.minecraft.polished_deepslate_stairs": "Polyste laaistiennen trep",
  "block.minecraft.polished_deepslate_wall": "Polyste laaistiennen muorre",
  "block.minecraft.polished_diorite": "Polyste dioryt",
  "block.minecraft.polished_diorite_slab": "Polyste dioriten plaat",
  "block.minecraft.polished_diorite_stairs": "Polyste dioriten trep",
  "block.minecraft.polished_granite": "Polyste granyt",
  "block.minecraft.polished_granite_slab": "Polyste graniten plaat",
  "block.minecraft.polished_granite_stairs": "Polyste graniten trep",
  "block.minecraft.polished_tuff": "Polyste dowestien",
  "block.minecraft.polished_tuff_slab": "Polyste dowestiennen plaat",
  "block.minecraft.polished_tuff_stairs": "Polyste dowestiennen trep",
  "block.minecraft.polished_tuff_wall": "Polyste dowestiennen muorre",
  "block.minecraft.poppy": "Klaproas",
  "block.minecraft.potatoes": "Ierappels",
  "block.minecraft.potted_acacia_sapling": "Oppotte akasiakiemplant",
  "block.minecraft.potted_allium": "Oppotte look",
  "block.minecraft.potted_azalea_bush": "Oppotte azalea",
  "block.minecraft.potted_azure_bluet": "Oppotte porseleinstjerke",
  "block.minecraft.potted_bamboo": "Oppotte bamboe",
  "block.minecraft.potted_birch_sapling": "Oppotte bjirkekiemplant",
  "block.minecraft.potted_blue_orchid": "Oppotte blauwe orchidee",
  "block.minecraft.potted_brown_mushroom": "Oppotte brune poddestoel",
  "block.minecraft.potted_cactus": "Oppotte kaktus",
  "block.minecraft.potted_cherry_sapling": "Oppotte kersesiedling",
  "block.minecraft.potted_closed_eyeblossom": "Potted Closed Eyeblossom",
  "block.minecraft.potted_cornflower": "Oppotte koarnblom",
  "block.minecraft.potted_crimson_fungus": "Oppotte helreade swam",
  "block.minecraft.potted_crimson_roots": "Oppotte helreade woartels",
  "block.minecraft.potted_dandelion": "Oppotte hynsteblom",
  "block.minecraft.potted_dark_oak_sapling": "Oppotte donker ikekiemplant",
  "block.minecraft.potted_dead_bush": "Oppotte deade strûk",
  "block.minecraft.potted_fern": "Oppotte fear",
  "block.minecraft.potted_flowering_azalea_bush": "Oppotte bloeiende azalea",
  "block.minecraft.potted_golden_dandelion": "Potted Golden Dandelion",
  "block.minecraft.potted_jungle_sapling": "Oppotte oerwâldkiemplant",
  "block.minecraft.potted_lily_of_the_valley": "Oppotte  lely-fan-de-delte",
  "block.minecraft.potted_mangrove_propagule": "Oppotte mangrovebroedknop",
  "block.minecraft.potted_oak_sapling": "Oppotte ikekiemplant",
  "block.minecraft.potted_open_eyeblossom": "Potted Open Eyeblossom",
  "block.minecraft.potted_orange_tulip": "Oppotte oranje tulp",
  "block.minecraft.potted_oxeye_daisy": "Oppotte margryt",
  "block.minecraft.potted_pale_oak_sapling": "Potted Pale Oak Sapling",
  "block.minecraft.potted_pink_tulip": "Oppotte rôze tulp",
  "block.minecraft.potted_poppy": "Oppotte klaproas",
  "block.minecraft.potted_red_mushroom": "Oppotte reade poddestoel",
  "block.minecraft.potted_red_tulip": "Oppotte reade tulp",
  "block.minecraft.potted_spruce_sapling": "Oppotte spjirrekiemplant",
  "block.minecraft.potted_torchflower": "Oppotte fakkelblom",
  "block.minecraft.potted_warped_fungus": "Oppotte spûkeftige swam",
  "block.minecraft.potted_warped_roots": "Oppotte spûkeftige woartels",
  "block.minecraft.potted_white_tulip": "Oppotte wite tulp",
  "block.minecraft.potted_wither_rose": "Oppotte witherroas",
  "block.minecraft.powder_snow": "Poeiersnie",
  "block.minecraft.powder_snow_cauldron": "Tsjettel mei poeiersnie",
  "block.minecraft.powered_rail": "Oandriuwspoar",
  "block.minecraft.prismarine": "Prismarine",
  "block.minecraft.prismarine_brick_slab": "Prismarine stiennen plaat",
  "block.minecraft.prismarine_brick_stairs": "Prismarine stiennen trep",
  "block.minecraft.prismarine_bricks": "Prismarine stiennen",
  "block.minecraft.prismarine_slab": "Prismarine plaat",
  "block.minecraft.prismarine_stairs": "Prismarine trep",
  "block.minecraft.prismarine_wall": "Prismarinemuorre",
  "block.minecraft.pumpkin": "Pompoen",
  "block.minecraft.pumpkin_stem": "Pompoenstam",
  "block.minecraft.purple_banner": "Pearze banier",
  "block.minecraft.purple_bed": "Pears bêd",
  "block.minecraft.purple_candle": "Pearse kears",
  "block.minecraft.purple_candle_cake": "Taart mei in pearze kears",
  "block.minecraft.purple_carpet": "Pears tapyt",
  "block.minecraft.purple_concrete": "Pears beton",
  "block.minecraft.purple_concrete_powder": "Pears semint",
  "block.minecraft.purple_glazed_terracotta": "Pears glazuere terrakotta",
  "block.minecraft.purple_shulker_box": "Pearze Shulker-doaze",
  "block.minecraft.purple_stained_glass": "Pears kleurd glês",
  "block.minecraft.purple_stained_glass_pane": "Pears kleurd glês",
  "block.minecraft.purple_terracotta": "Pearze terrakotta",
  "block.minecraft.purple_wool": "Pearze wol",
  "block.minecraft.purpur_block": "Purpurblok",
  "block.minecraft.purpur_pillar": "Purpurpylder",
  "block.minecraft.purpur_slab": "Purpurplaat",
  "block.minecraft.purpur_stairs": "Purpurtrep",
  "block.minecraft.quartz_block": "Kwartsblok",
  "block.minecraft.quartz_bricks": "Kwartsblokstiennen",
  "block.minecraft.quartz_pillar": "Kwartspilaar",
  "block.minecraft.quartz_slab": "Kwartsplaat",
  "block.minecraft.quartz_stairs": "Kwartstrep",
  "block.minecraft.rail": "Spoar",
  "block.minecraft.raw_copper_block": "Rûch koperblok",
  "block.minecraft.raw_gold_block": "Rûch goudblok",
  "block.minecraft.raw_iron_block": "Rûch izerblok",
  "block.minecraft.red_banner": "Reade banier",
  "block.minecraft.red_bed": "Read bêd",
  "block.minecraft.red_candle": "Reade kears",
  "block.minecraft.red_candle_cake": "Taart mei in reade kears",
  "block.minecraft.red_carpet": "Read tapyt",
  "block.minecraft.red_concrete": "Read beton",
  "block.minecraft.red_concrete_powder": "Read semint",
  "block.minecraft.red_glazed_terracotta": "Read glazuere terrakotta",
  "block.minecraft.red_mushroom": "Reade poddestoel",
  "block.minecraft.red_mushroom_block": "Reade poddestoeleblok",
  "block.minecraft.red_nether_brick_slab": "Reade Netherbakstiennen plaat",
  "block.minecraft.red_nether_brick_stairs": "Reade Netherbakstiennen trep",
  "block.minecraft.red_nether_brick_wall": "Reade Netherbakstiennen muorre",
  "block.minecraft.red_nether_bricks": "Reade Netherbakstien",
  "block.minecraft.red_sand": "Read sân",
  "block.minecraft.red_sandstone": "Reade sânstien",
  "block.minecraft.red_sandstone_slab": "Reade sânstiennen plaat",
  "block.minecraft.red_sandstone_stairs": "Reade sânstiennen trep",
  "block.minecraft.red_sandstone_wall": "Reade sânstiennen muorre",
  "block.minecraft.red_shulker_box": "Reade Shulker-doaze",
  "block.minecraft.red_stained_glass": "Read kleurd glês",
  "block.minecraft.red_stained_glass_pane": "Read kleurd glês",
  "block.minecraft.red_terracotta": "Reade terrakotta",
  "block.minecraft.red_tulip": "Reade tulp",
  "block.minecraft.red_wool": "Reade wol",
  "block.minecraft.redstone_block": "Redstone-blok",
  "block.minecraft.redstone_lamp": "Redstone-lampe",
  "block.minecraft.redstone_ore": "Redstone-erts",
  "block.minecraft.redstone_torch": "Redstonefakkel",
  "block.minecraft.redstone_wall_torch": "Redstone muorrefakkel",
  "block.minecraft.redstone_wire": "Redstonetried",
  "block.minecraft.reinforced_deepslate": "Fersterke laaistien",
  "block.minecraft.repeater": "Redstone-fersterker",
  "block.minecraft.repeating_command_block": "Werheljend opdrachtblok",
  "block.minecraft.resin_block": "Block of Resin",
  "block.minecraft.resin_brick_slab": "Resin Brick Slab",
  "block.minecraft.resin_brick_stairs": "Resin Brick Stairs",
  "block.minecraft.resin_brick_wall": "Resin Brick Wall",
  "block.minecraft.resin_bricks": "Resin Bricks",
  "block.minecraft.resin_clump": "Resin Clump",
  "block.minecraft.respawn_anchor": "Respawnanker",
  "block.minecraft.rooted_dirt": "Woartele ierde",
  "block.minecraft.rose_bush": "Roazestrûk",
  "block.minecraft.sand": "Sân",
  "block.minecraft.sandstone": "Sânstien",
  "block.minecraft.sandstone_slab": "Sânstiennen plaat",
  "block.minecraft.sandstone_stairs": "Sânstiennen trep",
  "block.minecraft.sandstone_wall": "Sânstiennen muorre",
  "block.minecraft.scaffolding": "Steger",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculkkatalysator",
  "block.minecraft.sculk_sensor": "Sculksensor",
  "block.minecraft.sculk_shrieker": "Sculkskriemer",
  "block.minecraft.sculk_vein": "Sculkader",
  "block.minecraft.sea_lantern": "Seelantearn",
  "block.minecraft.sea_pickle": "See-augurk",
  "block.minecraft.seagrass": "Seegers",
  "block.minecraft.set_spawn": "Respawnpunt ynsteld",
  "block.minecraft.short_dry_grass": "Short Dry Grass",
  "block.minecraft.short_grass": "Koart gers",
  "block.minecraft.shroomlight": "Swammeljocht",
  "block.minecraft.shulker_box": "Shulker-doaze",
  "block.minecraft.skeleton_skull": "Deadskop",
  "block.minecraft.skeleton_wall_skull": "Deadskop oan de muorre",
  "block.minecraft.slime_block": "Slymblok",
  "block.minecraft.small_amethyst_bud": "Lytse ametistknop",
  "block.minecraft.small_dripleaf": "Lyts dripblêd",
  "block.minecraft.smithing_table": "Smeitafel",
  "block.minecraft.smoker": "Smoker",
  "block.minecraft.smooth_basalt": "Glêd basalt",
  "block.minecraft.smooth_quartz": "Glêd kwartsblok",
  "block.minecraft.smooth_quartz_slab": "Glêde kwartsplaat",
  "block.minecraft.smooth_quartz_stairs": "Glêde kwartstrep",
  "block.minecraft.smooth_red_sandstone": "Glêde reade sânstien",
  "block.minecraft.smooth_red_sandstone_slab": "Glêde reade sânstiennen plaat",
  "block.minecraft.smooth_red_sandstone_stairs": "Glêde reade sânstiennen trep",
  "block.minecraft.smooth_sandstone": "Glêde sânstien",
  "block.minecraft.smooth_sandstone_slab": "Glêde sânstiennen plaat",
  "block.minecraft.smooth_sandstone_stairs": "Glêde sânstiennen trep",
  "block.minecraft.smooth_stone": "Glêde stien",
  "block.minecraft.smooth_stone_slab": "Glêde stiennen plaat",
  "block.minecraft.sniffer_egg": "Sneupersaai",
  "block.minecraft.snow": "Snie",
  "block.minecraft.snow_block": "Snieblok",
  "block.minecraft.soul_campfire": "Sielekampfjoer",
  "block.minecraft.soul_fire": "Sielefjoer",
  "block.minecraft.soul_lantern": "Sielelantearn",
  "block.minecraft.soul_sand": "Sielesân",
  "block.minecraft.soul_soil": "Siele-ierde",
  "block.minecraft.soul_torch": "Sielefakkel",
  "block.minecraft.soul_wall_torch": "Sielefakkel oan muorre",
  "block.minecraft.spawn.not_valid": "Do hast gjin bêd of opladen respawnanker, of se waarden blokkearre",
  "block.minecraft.spawner": "Meunsterkoai",
  "block.minecraft.spawner.desc1": "Ynteraksje meo spawnaai:",
  "block.minecraft.spawner.desc2": "Bepaalt te spawnen wêzentype",
  "block.minecraft.sponge": "Spûns",
  "block.minecraft.spore_blossom": "Sporebloesem",
  "block.minecraft.spruce_button": "Spjirrehouten knop",
  "block.minecraft.spruce_door": "Spjirrehouten doar",
  "block.minecraft.spruce_fence": "Spjirrehouten stek",
  "block.minecraft.spruce_fence_gate": "Spjirrehouten stekpoartsje",
  "block.minecraft.spruce_hanging_sign": "Sparrehouten úthingboerd",
  "block.minecraft.spruce_leaves": "Spjirrenullen",
  "block.minecraft.spruce_log": "Spjirrestam",
  "block.minecraft.spruce_planks": "Spjirrehouten planken",
  "block.minecraft.spruce_pressure_plate": "Spjirrehouten drukplaat",
  "block.minecraft.spruce_sapling": "Spjirrekymplant",
  "block.minecraft.spruce_shelf": "Spruce Shelf",
  "block.minecraft.spruce_sign": "Spjirrehouten boerd",
  "block.minecraft.spruce_slab": "Spjirrehouten plaat",
  "block.minecraft.spruce_stairs": "Spjirrehouten trep",
  "block.minecraft.spruce_trapdoor": "Spjirrehouten fallûk",
  "block.minecraft.spruce_wall_hanging_sign": "Sparrehouten úthingboerd",
  "block.minecraft.spruce_wall_sign": "Spjirrehouten muorreboerd",
  "block.minecraft.spruce_wood": "Spjirrehout",
  "block.minecraft.sticky_piston": "Kleefsûger",
  "block.minecraft.stone": "Stien",
  "block.minecraft.stone_brick_slab": "Blokstiennen plaat",
  "block.minecraft.stone_brick_stairs": "Houstiennen trep",
  "block.minecraft.stone_brick_wall": "Blokstiennen muorre",
  "block.minecraft.stone_bricks": "Blokstiennen",
  "block.minecraft.stone_button": "Stiennen knop",
  "block.minecraft.stone_pressure_plate": "Stiennen drukplaat",
  "block.minecraft.stone_slab": "Stiennen plaat",
  "block.minecraft.stone_stairs": "Stiennen trep",
  "block.minecraft.stonecutter": "Stiensliper",
  "block.minecraft.stripped_acacia_log": "Stripte akasiastam",
  "block.minecraft.stripped_acacia_wood": "Stripte akasiahout",
  "block.minecraft.stripped_bamboo_block": "Stript bamboeblok",
  "block.minecraft.stripped_birch_log": "Stripte bjirkestam",
  "block.minecraft.stripped_birch_wood": "Stripte bjirkehout",
  "block.minecraft.stripped_cherry_log": "Stripte kersehouten stam",
  "block.minecraft.stripped_cherry_wood": "Stripte kersehout",
  "block.minecraft.stripped_crimson_hyphae": "Stripte helreade skimmeltrieden",
  "block.minecraft.stripped_crimson_stem": "Stripte helreade stam",
  "block.minecraft.stripped_dark_oak_log": "Stripte donker ikestam",
  "block.minecraft.stripped_dark_oak_wood": "Stripte donker ikehout",
  "block.minecraft.stripped_jungle_log": "Stripte oerwâldstam",
  "block.minecraft.stripped_jungle_wood": "Stripte oerwâldhout",
  "block.minecraft.stripped_mangrove_log": "Stripte mangrovestam",
  "block.minecraft.stripped_mangrove_wood": "Stript mangrovehout",
  "block.minecraft.stripped_oak_log": "Stripte ikestam",
  "block.minecraft.stripped_oak_wood": "Stripte ikehout",
  "block.minecraft.stripped_pale_oak_log": "Stripped Pale Oak Log",
  "block.minecraft.stripped_pale_oak_wood": "Stripped Pale Oak Wood",
  "block.minecraft.stripped_spruce_log": "Stripte spjirrestam",
  "block.minecraft.stripped_spruce_wood": "Stripte spjirrehout",
  "block.minecraft.stripped_warped_hyphae": "Stripte spûkeftige skimmeltrieden",
  "block.minecraft.stripped_warped_stem": "Stripte spûkeftige stam",
  "block.minecraft.structure_block": "Struktuerblok",
  "block.minecraft.structure_void": "Struktuerleechte",
  "block.minecraft.sugar_cane": "Sûkerreid",
  "block.minecraft.sunflower": "Sinneblom",
  "block.minecraft.suspicious_gravel": "Fertocht grint",
  "block.minecraft.suspicious_sand": "Fertocht sân",
  "block.minecraft.sweet_berry_bush": "Swietbesstrúk",
  "block.minecraft.tall_dry_grass": "Heech drûch gers",
  "block.minecraft.tall_grass": "Heech gers",
  "block.minecraft.tall_seagrass": "Heech seegers",
  "block.minecraft.target": "Doel",
  "block.minecraft.terracotta": "Terrakotta",
  "block.minecraft.test_block": "Testblok",
  "block.minecraft.test_instance_block": "Testynstânsjeblok",
  "block.minecraft.tinted_glass": "Tinte glês",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "TNT explosions are disabled",
  "block.minecraft.torch": "Fakkel",
  "block.minecraft.torchflower": "Fakkelblom",
  "block.minecraft.torchflower_crop": "Fakkelblomwaaks",
  "block.minecraft.trapped_chest": "Kiste mei falstrik",
  "block.minecraft.trial_spawner": "Beproevingskoai",
  "block.minecraft.tripwire": "Stroffeltried",
  "block.minecraft.tripwire_hook": "Stroffeltriedheak",
  "block.minecraft.tube_coral": "Buiskoraal",
  "block.minecraft.tube_coral_block": "Buiskoraalblok",
  "block.minecraft.tube_coral_fan": "Buisgorgoon",
  "block.minecraft.tube_coral_wall_fan": "Buiskoraalwaaier oan muorre",
  "block.minecraft.tuff": "Dowestien",
  "block.minecraft.tuff_brick_slab": "Dowestiennen blokstiennen plaat",
  "block.minecraft.tuff_brick_stairs": "Dowestiennen blokstiennen trep",
  "block.minecraft.tuff_brick_wall": "Dowestiennen blokstiennen muorre",
  "block.minecraft.tuff_bricks": "Dowestiennen blokstiennen",
  "block.minecraft.tuff_slab": "Dowestiennen plaat",
  "block.minecraft.tuff_stairs": "Dowestiennen trep",
  "block.minecraft.tuff_wall": "Dowestiennen muorre",
  "block.minecraft.turtle_egg": "Skyldpodaai",
  "block.minecraft.twisting_vines": "Draaiende lianen",
  "block.minecraft.twisting_vines_plant": "Draaiende lianeplant",
  "block.minecraft.vault": "Klûs",
  "block.minecraft.verdant_froglight": "Grien kikkertljocht",
  "block.minecraft.vine": "Lianen",
  "block.minecraft.void_air": "Luchtliddich",
  "block.minecraft.wall_torch": "Muorrefakkel",
  "block.minecraft.warped_button": "Spûkeftich houten knop",
  "block.minecraft.warped_door": "Spûkeftich houten doar",
  "block.minecraft.warped_fence": "Spûkeftich houten hek",
  "block.minecraft.warped_fence_gate": "Spûkeftich houten poarte",
  "block.minecraft.warped_fungus": "Spûkeftige swam",
  "block.minecraft.warped_hanging_sign": "Spûkeftich houten úthingboerd",
  "block.minecraft.warped_hyphae": "Spûkeftige skimmeltrieden",
  "block.minecraft.warped_nylium": "Spûkeftich nylium",
  "block.minecraft.warped_planks": "Spûkeftige houten planken",
  "block.minecraft.warped_pressure_plate": "Spûkeftige houten drukplaat",
  "block.minecraft.warped_roots": "Spûkeftige woartels",
  "block.minecraft.warped_shelf": "Warped Shelf",
  "block.minecraft.warped_sign": "Spûkeftich houten boerd",
  "block.minecraft.warped_slab": "Spûkeftige houten plaat",
  "block.minecraft.warped_stairs": "Spûkeftich houten trep",
  "block.minecraft.warped_stem": "Spûkeftige stam",
  "block.minecraft.warped_trapdoor": "Spûkeftich houten fallûk",
  "block.minecraft.warped_wall_hanging_sign": "Spûkeftich houten úthingboerd",
  "block.minecraft.warped_wall_sign": "Spûkeftich boerd oan muorre",
  "block.minecraft.warped_wart_block": "Spûkeftich krûdblok",
  "block.minecraft.water": "Wetter",
  "block.minecraft.water_cauldron": "Tsjettel mei wetter",
  "block.minecraft.waxed_chiseled_copper": "Wakst bewurke koperblok",
  "block.minecraft.waxed_copper_bars": "Waxed Copper Bars",
  "block.minecraft.waxed_copper_block": "Wakst koperblok",
  "block.minecraft.waxed_copper_bulb": "Wakst koperen lampe",
  "block.minecraft.waxed_copper_chain": "Waxed Copper Chain",
  "block.minecraft.waxed_copper_chest": "Waxed Copper Chest",
  "block.minecraft.waxed_copper_door": "Wakst koperen doar",
  "block.minecraft.waxed_copper_golem_statue": "Waxed Copper Golem Statue",
  "block.minecraft.waxed_copper_grate": "Wakst koperen roaster",
  "block.minecraft.waxed_copper_lantern": "Waxed Copper Lantern",
  "block.minecraft.waxed_copper_trapdoor": "Wakst koperen fallûk",
  "block.minecraft.waxed_cut_copper": "Wakst snijd koperblok",
  "block.minecraft.waxed_cut_copper_slab": "Wakst snijd koperen plaat",
  "block.minecraft.waxed_cut_copper_stairs": "Wakst snijd koperen trep",
  "block.minecraft.waxed_exposed_chiseled_copper": "Wakst bleatsteld bewurke koperblok",
  "block.minecraft.waxed_exposed_copper": "Wakst bleatsteld koperblok",
  "block.minecraft.waxed_exposed_copper_bars": "Waxed Exposed Copper Bars",
  "block.minecraft.waxed_exposed_copper_bulb": "Wakst bleatstelde koperen lampe",
  "block.minecraft.waxed_exposed_copper_chain": "Waxed Exposed Copper Chain",
  "block.minecraft.waxed_exposed_copper_chest": "Waxed Exposed Copper Chest",
  "block.minecraft.waxed_exposed_copper_door": "Wakst bleatstelde koperen doar",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Waxed Exposed Copper Golem Statue",
  "block.minecraft.waxed_exposed_copper_grate": "Wakst bleatstelde koperen roaster",
  "block.minecraft.waxed_exposed_copper_lantern": "Waxed Exposed Copper Lantern",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Wakst bleatstelde koperen fallûk",
  "block.minecraft.waxed_exposed_cut_copper": "Wakst bleatsteld snijd koperblok",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Wakst bleatstelede snijd koperen plaat",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Wakst bleatsteld snijd koperen trep",
  "block.minecraft.waxed_exposed_lightning_rod": "Waxed Exposed Lightning Rod",
  "block.minecraft.waxed_lightning_rod": "Waxed Lightning Rod",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Wakst oksidearre bewurke koperblok",
  "block.minecraft.waxed_oxidized_copper": "Wakst oksidearre koperblok",
  "block.minecraft.waxed_oxidized_copper_bars": "Waxed Oxidized Copper Bars",
  "block.minecraft.waxed_oxidized_copper_bulb": "Wakst oksidearre koperen lampe",
  "block.minecraft.waxed_oxidized_copper_chain": "Waxed Oxidized Copper Chain",
  "block.minecraft.waxed_oxidized_copper_chest": "Waxed Oxidized Copper Chest",
  "block.minecraft.waxed_oxidized_copper_door": "Wakst oksidearre koperen doar",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Waxed Oxidized Copper Golem Statue",
  "block.minecraft.waxed_oxidized_copper_grate": "Wakst oksidearre koperen roaster",
  "block.minecraft.waxed_oxidized_copper_lantern": "Waxed Oxidized Copper Lantern",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Wakst oksidearre koperen fallûk",
  "block.minecraft.waxed_oxidized_cut_copper": "Wakst oksidearre snijd koperblok",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Wakst oksidearre snijd koperen plaat",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Wakst oksidearre snijd koperen trep",
  "block.minecraft.waxed_oxidized_lightning_rod": "Waxed Oxidized Lightning Rod",
  "block.minecraft.waxed_weathered_chiseled_copper": "Wakst ferware bewurke koperblok",
  "block.minecraft.waxed_weathered_copper": "Wakst ferware koperblok",
  "block.minecraft.waxed_weathered_copper_bars": "Waxed Weathered Copper Bars",
  "block.minecraft.waxed_weathered_copper_bulb": "Wakst ferware koperen lampe",
  "block.minecraft.waxed_weathered_copper_chain": "Waxed Weathered Copper Chain",
  "block.minecraft.waxed_weathered_copper_chest": "Waxed Weathered Copper Chest",
  "block.minecraft.waxed_weathered_copper_door": "Wakst ferware koperen doar",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Waxed Weathered Copper Golem Statue",
  "block.minecraft.waxed_weathered_copper_grate": "Wakst ferware koperen roaster",
  "block.minecraft.waxed_weathered_copper_lantern": "Waxed Weathered Copper Lantern",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Wakst ferware koperen fallûk",
  "block.minecraft.waxed_weathered_cut_copper": "Wakst ferware snijd koperblok",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Wakst ferware snijd koperen plaat",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Wakst ferware snijd koperen trep",
  "block.minecraft.waxed_weathered_lightning_rod": "Waxed Weathered Lightning Rod",
  "block.minecraft.weathered_chiseled_copper": "Ferware bewurke koperblok",
  "block.minecraft.weathered_copper": "Ferware koper",
  "block.minecraft.weathered_copper_bars": "Weathered Copper Bars",
  "block.minecraft.weathered_copper_bulb": "Ferware koperen lampe",
  "block.minecraft.weathered_copper_chain": "Weathered Copper Chain",
  "block.minecraft.weathered_copper_chest": "Weathered Copper Chest",
  "block.minecraft.weathered_copper_door": "Ferware koperen doar",
  "block.minecraft.weathered_copper_golem_statue": "Weathered Copper Golem Statue",
  "block.minecraft.weathered_copper_grate": "Ferware koperen roaster",
  "block.minecraft.weathered_copper_lantern": "Weathered Copper Lantern",
  "block.minecraft.weathered_copper_trapdoor": "Ferware koperen fallûk",
  "block.minecraft.weathered_cut_copper": "Ferware snijd koperblok",
  "block.minecraft.weathered_cut_copper_slab": "Ferware snijde koperen plaat",
  "block.minecraft.weathered_cut_copper_stairs": "Ferware snijde koperen trep",
  "block.minecraft.weathered_lightning_rod": "Weathered Lightning Rod",
  "block.minecraft.weeping_vines": "Hingjende klimmerblêd",
  "block.minecraft.weeping_vines_plant": "Hingjende klimplant",
  "block.minecraft.wet_sponge": "Wiete spûns",
  "block.minecraft.wheat": "Weet",
  "block.minecraft.white_banner": "Wite banier",
  "block.minecraft.white_bed": "Wyt bêd",
  "block.minecraft.white_candle": "Wite kears",
  "block.minecraft.white_candle_cake": "Taart mei in witte kears",
  "block.minecraft.white_carpet": "Wyt tapyt",
  "block.minecraft.white_concrete": "Wyt beton",
  "block.minecraft.white_concrete_powder": "Wyt semint",
  "block.minecraft.white_glazed_terracotta": "Wyt glazuere terrakotta",
  "block.minecraft.white_shulker_box": "Wite Shulker-doaze",
  "block.minecraft.white_stained_glass": "Wyt kleurd glês",
  "block.minecraft.white_stained_glass_pane": "Wyt kleurd glês",
  "block.minecraft.white_terracotta": "Wite terrakotta",
  "block.minecraft.white_tulip": "Wite tulp",
  "block.minecraft.white_wool": "Wite wol",
  "block.minecraft.wildflowers": "Wildflowers",
  "block.minecraft.wither_rose": "Witherroas",
  "block.minecraft.wither_skeleton_skull": "Wither-bonkerakkekop",
  "block.minecraft.wither_skeleton_wall_skull": "Witherbonkerakkekop oan de muorre",
  "block.minecraft.yellow_banner": "Giele banier",
  "block.minecraft.yellow_bed": "Giel bêd",
  "block.minecraft.yellow_candle": "Giele kears",
  "block.minecraft.yellow_candle_cake": "Taart mei in giele kears",
  "block.minecraft.yellow_carpet": "Giel tapyt",
  "block.minecraft.yellow_concrete": "Giel beton",
  "block.minecraft.yellow_concrete_powder": "Giel semint",
  "block.minecraft.yellow_glazed_terracotta": "Giel glazuere terrakotta",
  "block.minecraft.yellow_shulker_box": "Giele Shulker-doaze",
  "block.minecraft.yellow_stained_glass": "Giel kleurd glês",
  "block.minecraft.yellow_stained_glass_pane": "Giel kleurd glês",
  "block.minecraft.yellow_terracotta": "Giele terrakotta",
  "block.minecraft.yellow_wool": "Giele wol",
  "block.minecraft.zombie_head": "Sombykop",
  "block.minecraft.zombie_wall_head": "Sombyholle oan muorre",
  "item.minecraft.acacia_boat": "Akasiahouten boat",
  "item.minecraft.acacia_chest_boat": "Akaciahouten boat mei kiste",
  "item.minecraft.allay_spawn_egg": "Helperspawnaai",
  "item.minecraft.amethyst_shard": "Ametistskerf",
  "item.minecraft.angler_pottery_shard": "Ierdewurkskerf ‘fisker’",
  "item.minecraft.angler_pottery_sherd": "Ierdewurk diggel fisker",
  "item.minecraft.apple": "Appel",
  "item.minecraft.archer_pottery_shard": "Ierdewurkskerf ‘bôgeskutter’",
  "item.minecraft.archer_pottery_sherd": "Ierdewurk diggel bôgeskutter",
  "item.minecraft.armadillo_scute": "Gurdledier hoarnplaat",
  "item.minecraft.armadillo_spawn_egg": "Gurdledierspawnaai",
  "item.minecraft.armor_stand": "Wapenhâlder",
  "item.minecraft.arms_up_pottery_shard": "Ierdewurkskerf ‘earms omheech’",
  "item.minecraft.arms_up_pottery_sherd": "Ierdewurk diggel earms omheech",
  "item.minecraft.arrow": "Pylk",
  "item.minecraft.axolotl_bucket": "Amer axolotl",
  "item.minecraft.axolotl_spawn_egg": "Axolotlspawnaai",
  "item.minecraft.baked_potato": "Bakte ierappel",
  "item.minecraft.bamboo_chest_raft": "Bamboeflot mei kiste",
  "item.minecraft.bamboo_raft": "Bamboeflot",
  "item.minecraft.bat_spawn_egg": "Flearmûzespawnaai",
  "item.minecraft.bee_spawn_egg": "Bijespawnaai",
  "item.minecraft.beef": "Rau kowefleis",
  "item.minecraft.beetroot": "Byt",
  "item.minecraft.beetroot_seeds": "Bitesieden",
  "item.minecraft.beetroot_soup": "Bitesop",
  "item.minecraft.birch_boat": "Bjirkehouten boat",
  "item.minecraft.birch_chest_boat": "Bjirkehouten boat mei kiste",
  "item.minecraft.black_bundle": "Black Bundle",
  "item.minecraft.black_dye": "Swarte kleurstof",
  "item.minecraft.black_harness": "Black Harness",
  "item.minecraft.blade_pottery_shard": "Ierdewurkskerf ‘swurd’",
  "item.minecraft.blade_pottery_sherd": "Ierdewurk diggel swurd",
  "item.minecraft.blaze_powder": "Blazepoeier",
  "item.minecraft.blaze_rod": "Blazestêf",
  "item.minecraft.blaze_spawn_egg": "Blazespawnaai",
  "item.minecraft.blue_bundle": "Blue Bundle",
  "item.minecraft.blue_dye": "Blauwe kleurstof",
  "item.minecraft.blue_egg": "Blau aai",
  "item.minecraft.blue_harness": "Blue Harness",
  "item.minecraft.bogged_spawn_egg": "Bogged Spawn Egg",
  "item.minecraft.bolt_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Bolt Armor Trim",
  "item.minecraft.bone": "Bonke",
  "item.minecraft.bone_meal": "Bonkemoal",
  "item.minecraft.book": "Boek",
  "item.minecraft.bordure_indented_banner_pattern": "Bordure Indented Banner Pattern",
  "item.minecraft.bow": "Bôge",
  "item.minecraft.bowl": "Kom",
  "item.minecraft.bread": "Bôle",
  "item.minecraft.breeze_rod": "Breeze Rod",
  "item.minecraft.breeze_spawn_egg": "Breeze Spawn Egg",
  "item.minecraft.brewer_pottery_shard": "Ierdewurkskerf ‘brouwer’",
  "item.minecraft.brewer_pottery_sherd": "Ierdewurk diggel brouwer",
  "item.minecraft.brewing_stand": "Broustandert",
  "item.minecraft.brick": "Bakstien",
  "item.minecraft.brown_bundle": "Brown Bundle",
  "item.minecraft.brown_dye": "Brune kleurstof",
  "item.minecraft.brown_egg": "Brún aai",
  "item.minecraft.brown_harness": "Brown Harness",
  "item.minecraft.brush": "Boarstel",
  "item.minecraft.bucket": "Amer",
  "item.minecraft.bundle": "Bondel",
  "item.minecraft.bundle.empty": "Leech",
  "item.minecraft.bundle.empty.description": "Can hold a mixed stack of items",
  "item.minecraft.bundle.full": "Fol",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Ierdewurkskerf ‘flammen’",
  "item.minecraft.burn_pottery_sherd": "Ierdewurk diggel flammen",
  "item.minecraft.camel_husk_spawn_egg": "Camel Husk Spawn Egg",
  "item.minecraft.camel_spawn_egg": "Dromedarisspawnaai",
  "item.minecraft.carrot": "Woartel",
  "item.minecraft.carrot_on_a_stick": "Woartel oan in stôk",
  "item.minecraft.cat_spawn_egg": "Kattespawnaai",
  "item.minecraft.cauldron": "Tsjettel",
  "item.minecraft.cave_spider_spawn_egg": "Grottenspinnespawnaai",
  "item.minecraft.chainmail_boots": "Maljenlearzens",
  "item.minecraft.chainmail_chestplate": "Maljenkolder",
  "item.minecraft.chainmail_helmet": "Maljenkap",
  "item.minecraft.chainmail_leggings": "Maljenbroek",
  "item.minecraft.charcoal": "Houtskoal",
  "item.minecraft.cherry_boat": "Kersehouten boat",
  "item.minecraft.cherry_chest_boat": "Kersehouten boat mei kiste",
  "item.minecraft.chest_minecart": "Mynkarre mei kiste",
  "item.minecraft.chicken": "Rauwe hin",
  "item.minecraft.chicken_spawn_egg": "Hinnespawnaai",
  "item.minecraft.chorus_fruit": "Koarfrucht",
  "item.minecraft.clay_ball": "Klaaibal",
  "item.minecraft.clock": "Klok",
  "item.minecraft.coal": "Stienkoal",
  "item.minecraft.coast_armor_trim_smithing_template": "Smeisjabloan",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Coast Armor Trim",
  "item.minecraft.cocoa_beans": "Kakaobeane",
  "item.minecraft.cod": "Rauwe kabeljau",
  "item.minecraft.cod_bucket": "Amer kabbeljau",
  "item.minecraft.cod_spawn_egg": "Kabeljauspawnaai",
  "item.minecraft.command_block_minecart": "Mynkarre mei opdrachtblok",
  "item.minecraft.compass": "Kompas",
  "item.minecraft.cooked_beef": "Byfstik",
  "item.minecraft.cooked_chicken": "Brette hin",
  "item.minecraft.cooked_cod": "Siede kabeljau",
  "item.minecraft.cooked_mutton": "Bret skieppefleis",
  "item.minecraft.cooked_porkchop": "Bret bargefleis",
  "item.minecraft.cooked_rabbit": "Bret kninefleis",
  "item.minecraft.cooked_salmon": "Bakte salm",
  "item.minecraft.cookie": "Koekje",
  "item.minecraft.copper_axe": "Koperen bile",
  "item.minecraft.copper_boots": "Koperen learzens",
  "item.minecraft.copper_chestplate": "Koperen boarstplaat",
  "item.minecraft.copper_golem_spawn_egg": "Kopergolemspawnaai",
  "item.minecraft.copper_helmet": "Koperen helm",
  "item.minecraft.copper_hoe": "Koperen skoffel",
  "item.minecraft.copper_horse_armor": "Koperen hynsteharnas",
  "item.minecraft.copper_ingot": "Koperstêf",
  "item.minecraft.copper_leggings": "Koperen boksen",
  "item.minecraft.copper_nautilus_armor": "Copper Nautilus Armor",
  "item.minecraft.copper_nugget": "Copper Nugget",
  "item.minecraft.copper_pickaxe": "Copper Pickaxe",
  "item.minecraft.copper_shovel": "Copper Shovel",
  "item.minecraft.copper_spear": "Koperen spear",
  "item.minecraft.copper_sword": "Copper Sword",
  "item.minecraft.cow_spawn_egg": "Kowespawnaai",
  "item.minecraft.creaking_spawn_egg": "Creaking Spawn Egg",
  "item.minecraft.creeper_banner_pattern": "Banierpatroan",
  "item.minecraft.creeper_banner_pattern.desc": "Creeperwapen",
  "item.minecraft.creeper_banner_pattern.new": "Creeper Charge Banner Pattern",
  "item.minecraft.creeper_spawn_egg": "Creeperspawnaai",
  "item.minecraft.crossbow": "Krúsbôge",
  "item.minecraft.crossbow.projectile": "Projektyl:",
  "item.minecraft.crossbow.projectile.multiple": "Projectile: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Projectile: %s",
  "item.minecraft.cyan_bundle": "Cyan Bundle",
  "item.minecraft.cyan_dye": "Turkoaiske kleurstof",
  "item.minecraft.cyan_harness": "Cyan Harness",
  "item.minecraft.danger_pottery_shard": "Ierdewurkskerf ‘gefaar’",
  "item.minecraft.danger_pottery_sherd": "Ierdewurk diggel gefaar",
  "item.minecraft.dark_oak_boat": "Donkere ikehouten boat",
  "item.minecraft.dark_oak_chest_boat": "Donkerikehouten boat mei kiste",
  "item.minecraft.debug_stick": "Debugstôk",
  "item.minecraft.debug_stick.empty": "%s hat gjin eigenskippen",
  "item.minecraft.debug_stick.select": "‘%s’ selektearre (%s)",
  "item.minecraft.debug_stick.update": "‘%s’ nei %s",
  "item.minecraft.diamond": "Diamant",
  "item.minecraft.diamond_axe": "Diamanten bile",
  "item.minecraft.diamond_boots": "Diamanten learzens",
  "item.minecraft.diamond_chestplate": "Diamanten boarstplaat",
  "item.minecraft.diamond_helmet": "Diamanten helm",
  "item.minecraft.diamond_hoe": "Diamanten skoffel",
  "item.minecraft.diamond_horse_armor": "Diamanten hynsteharnas",
  "item.minecraft.diamond_leggings": "Diamanten boksen",
  "item.minecraft.diamond_nautilus_armor": "Diamond Nautilus Armor",
  "item.minecraft.diamond_pickaxe": "Diamanten houwiel",
  "item.minecraft.diamond_shovel": "Diamanten skeppe",
  "item.minecraft.diamond_spear": "Diamanten spear",
  "item.minecraft.diamond_sword": "Diamanten swurd",
  "item.minecraft.disc_fragment_5": "Elpee-fragmint",
  "item.minecraft.disc_fragment_5.desc": "Elpee - 5",
  "item.minecraft.dolphin_spawn_egg": "Dolfinespawnaai",
  "item.minecraft.donkey_spawn_egg": "Ezelspawnaai",
  "item.minecraft.dragon_breath": "Drake-azem",
  "item.minecraft.dried_kelp": "Droege kelp",
  "item.minecraft.drowned_spawn_egg": "Drinkelingespawnaai",
  "item.minecraft.dune_armor_trim_smithing_template": "Smeisjabloan",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Dune Armor Trim",
  "item.minecraft.echo_shard": "Echodiggel",
  "item.minecraft.egg": "Aai",
  "item.minecraft.elder_guardian_spawn_egg": "Aldebewakerspawnaai",
  "item.minecraft.elytra": "Dekskyld",
  "item.minecraft.emerald": "Smaragd",
  "item.minecraft.enchanted_book": "Betsjoene boek",
  "item.minecraft.enchanted_golden_apple": "Betsjoene gouden appel",
  "item.minecraft.end_crystal": "End-kristal",
  "item.minecraft.ender_dragon_spawn_egg": "Enderdrakespawnaai",
  "item.minecraft.ender_eye": "Ender-each",
  "item.minecraft.ender_pearl": "Ender-pearel",
  "item.minecraft.enderman_spawn_egg": "Endermannespawnaai",
  "item.minecraft.endermite_spawn_egg": "Endermitespawnaai",
  "item.minecraft.evoker_spawn_egg": "Opropperspawnaai",
  "item.minecraft.experience_bottle": "Tsjoendersflesse",
  "item.minecraft.explorer_pottery_shard": "Ierdewurkskerf ‘ûntdekker’",
  "item.minecraft.explorer_pottery_sherd": "Ierdewurk diggel ûntdekker",
  "item.minecraft.eye_armor_trim_smithing_template": "Smeisjabloan",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Eye Armor Trim",
  "item.minecraft.feather": "Fear",
  "item.minecraft.fermented_spider_eye": "Fermintearre spinne-each",
  "item.minecraft.field_masoned_banner_pattern": "Field Masoned Banner Pattern",
  "item.minecraft.filled_map": "Kaart",
  "item.minecraft.fire_charge": "Fjoerbal",
  "item.minecraft.firework_rocket": "Fjoerpylk",
  "item.minecraft.firework_rocket.flight": "Fleandoer:",
  "item.minecraft.firework_rocket.multiple_stars": "%s × %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Fjoerwurkstjer",
  "item.minecraft.firework_star.black": "Swart",
  "item.minecraft.firework_star.blue": "Blau",
  "item.minecraft.firework_star.brown": "Brún",
  "item.minecraft.firework_star.custom_color": "Oanpast",
  "item.minecraft.firework_star.cyan": "Turkoaise",
  "item.minecraft.firework_star.fade_to": "Oergong nei",
  "item.minecraft.firework_star.flicker": "Twinkeling",
  "item.minecraft.firework_star.gray": "Griis",
  "item.minecraft.firework_star.green": "Grien",
  "item.minecraft.firework_star.light_blue": "Ljochtblau",
  "item.minecraft.firework_star.light_gray": "Ljochtgriis",
  "item.minecraft.firework_star.lime": "Ljochtgrien",
  "item.minecraft.firework_star.magenta": "Maginta",
  "item.minecraft.firework_star.orange": "Oranje",
  "item.minecraft.firework_star.pink": "Rôze",
  "item.minecraft.firework_star.purple": "Pears",
  "item.minecraft.firework_star.red": "Read",
  "item.minecraft.firework_star.shape": "Unbekende foarm",
  "item.minecraft.firework_star.shape.burst": "Eksploazje",
  "item.minecraft.firework_star.shape.creeper": "Creeper-foarmich",
  "item.minecraft.firework_star.shape.large_ball": "Grutte bal",
  "item.minecraft.firework_star.shape.small_ball": "Lytse bal",
  "item.minecraft.firework_star.shape.star": "Stjerfoarmich",
  "item.minecraft.firework_star.trail": "Spoar",
  "item.minecraft.firework_star.white": "Wyt",
  "item.minecraft.firework_star.yellow": "Giel",
  "item.minecraft.fishing_rod": "Fiskangel",
  "item.minecraft.flint": "Fjoerstien",
  "item.minecraft.flint_and_steel": "Fjoerstien en stiel",
  "item.minecraft.flow_armor_trim_smithing_template": "Smeisjabloan",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Flow Armor Trim",
  "item.minecraft.flow_banner_pattern": "Banierpatroan",
  "item.minecraft.flow_banner_pattern.desc": "Flow",
  "item.minecraft.flow_banner_pattern.new": "Flow Banner Pattern",
  "item.minecraft.flow_pottery_sherd": "Flow Pottery Sherd",
  "item.minecraft.flower_banner_pattern": "Banierpatroan",
  "item.minecraft.flower_banner_pattern.desc": "Blomwapen",
  "item.minecraft.flower_banner_pattern.new": "Flower Charge Banner Pattern",
  "item.minecraft.flower_pot": "Blompot",
  "item.minecraft.fox_spawn_egg": "Foksspawnaai",
  "item.minecraft.friend_pottery_shard": "Ierdewurkskerf ‘freon’",
  "item.minecraft.friend_pottery_sherd": "Ierdewurk diggel freon",
  "item.minecraft.frog_spawn_egg": "Kikkertspawnaai",
  "item.minecraft.furnace_minecart": "Mynkarre mei oven",
  "item.minecraft.ghast_spawn_egg": "Ghastspawnaai",
  "item.minecraft.ghast_tear": "Ghast-trien",
  "item.minecraft.glass_bottle": "Glêzen fleske",
  "item.minecraft.glistering_melon_slice": "Glinsterjende meloenskiif",
  "item.minecraft.globe_banner_pattern": "Banierpatroan",
  "item.minecraft.globe_banner_pattern.desc": "Globe",
  "item.minecraft.globe_banner_pattern.new": "Globe Banner Pattern",
  "item.minecraft.glow_berries": "Gloeibessen",
  "item.minecraft.glow_ink_sac": "Gleon inketsek",
  "item.minecraft.glow_item_frame": "Gleon foarwerplist",
  "item.minecraft.glow_squid_spawn_egg": "Gleoninketfiskspawnaai",
  "item.minecraft.glowstone_dust": "Gleonstienstof",
  "item.minecraft.goat_horn": "Geitehoarn",
  "item.minecraft.goat_spawn_egg": "Geitespawnaai",
  "item.minecraft.gold_ingot": "Goudstêf",
  "item.minecraft.gold_nugget": "Goudklompke",
  "item.minecraft.golden_apple": "Gouden appel",
  "item.minecraft.golden_axe": "Gouden bile",
  "item.minecraft.golden_boots": "Gouden learzens",
  "item.minecraft.golden_carrot": "Gouden woartel",
  "item.minecraft.golden_chestplate": "Gouden boarstplaat",
  "item.minecraft.golden_helmet": "Gouden helm",
  "item.minecraft.golden_hoe": "Gouden skoffel",
  "item.minecraft.golden_horse_armor": "Gouden hynsteharnas",
  "item.minecraft.golden_leggings": "Gouden boksen",
  "item.minecraft.golden_nautilus_armor": "Golden Nautilus Armor",
  "item.minecraft.golden_pickaxe": "Gouden houwiel",
  "item.minecraft.golden_shovel": "Gouden skeppe",
  "item.minecraft.golden_spear": "Gouden spear",
  "item.minecraft.golden_sword": "Gouden swurd",
  "item.minecraft.gray_bundle": "Gray Bundle",
  "item.minecraft.gray_dye": "Grize kleurstof",
  "item.minecraft.gray_harness": "Gray Harness",
  "item.minecraft.green_bundle": "Green Bundle",
  "item.minecraft.green_dye": "Griene kleurstof",
  "item.minecraft.green_harness": "Green Harness",
  "item.minecraft.guardian_spawn_egg": "Bewakerspawnaai",
  "item.minecraft.gunpowder": "Buskrûd",
  "item.minecraft.guster_banner_pattern": "Banner Pattern",
  "item.minecraft.guster_banner_pattern.desc": "Guster",
  "item.minecraft.guster_banner_pattern.new": "Guster Banner Pattern",
  "item.minecraft.guster_pottery_sherd": "Guster Pottery Sherd",
  "item.minecraft.happy_ghast_spawn_egg": "Happy Ghast Spawn Egg",
  "item.minecraft.harness": "Harness",
  "item.minecraft.heart_of_the_sea": "Hert fan de see",
  "item.minecraft.heart_pottery_shard": "Ierdewurkskerf ‘hert’",
  "item.minecraft.heart_pottery_sherd": "Ierdewurk diggel hert",
  "item.minecraft.heartbreak_pottery_shard": "Ierdewurkskerf ‘brutsen hert’",
  "item.minecraft.heartbreak_pottery_sherd": "Ierdewurk diggel brutsen hert",
  "item.minecraft.hoglin_spawn_egg": "Hoglin Spawn Aai",
  "item.minecraft.honey_bottle": "Huningfles",
  "item.minecraft.honeycomb": "Huningraat",
  "item.minecraft.hopper_minecart": "Mynkarre mei trachter",
  "item.minecraft.horse_spawn_egg": "Hynstespawnaai",
  "item.minecraft.host_armor_trim_smithing_template": "Smeisjabloan",
  "item.minecraft.host_armor_trim_smithing_template.new": "Host Armor Trim",
  "item.minecraft.howl_pottery_shard": "Ierdewurkskerf ‘gûle’",
  "item.minecraft.howl_pottery_sherd": "Ierdewurk diggel gûle",
  "item.minecraft.husk_spawn_egg": "Mummyspawnaai",
  "item.minecraft.ink_sac": "Inketsek",
  "item.minecraft.iron_axe": "Izeren bile",
  "item.minecraft.iron_boots": "Izeren learzens",
  "item.minecraft.iron_chestplate": "Izeren boarstplaat",
  "item.minecraft.iron_golem_spawn_egg": "Izergolemspawnaai",
  "item.minecraft.iron_helmet": "Izeren helm",
  "item.minecraft.iron_hoe": "Izeren skoffel",
  "item.minecraft.iron_horse_armor": "Izeren hynsteharnas",
  "item.minecraft.iron_ingot": "Izeren stêf",
  "item.minecraft.iron_leggings": "Izeren boksen",
  "item.minecraft.iron_nautilus_armor": "Iron Nautilus Armor",
  "item.minecraft.iron_nugget": "Izerklompke",
  "item.minecraft.iron_pickaxe": "Izeren houwiel",
  "item.minecraft.iron_shovel": "Izeren skeppe",
  "item.minecraft.iron_spear": "Izeren spear",
  "item.minecraft.iron_sword": "Izeren swurd",
  "item.minecraft.item_frame": "Foarwerplist",
  "item.minecraft.jungle_boat": "Oerwâldhouten boat",
  "item.minecraft.jungle_chest_boat": "Oerwâldhouten boat mei kiste",
  "item.minecraft.knowledge_book": "Boek fan kennis",
  "item.minecraft.lapis_lazuli": "Lapis lazuli",
  "item.minecraft.lava_bucket": "Amer lava",
  "item.minecraft.lead": "Riem",
  "item.minecraft.leather": "Lear",
  "item.minecraft.leather_boots": "Learen learzens",
  "item.minecraft.leather_chestplate": "Learen tunyk",
  "item.minecraft.leather_helmet": "Learen kap",
  "item.minecraft.leather_horse_armor": "Learen hynderharnas",
  "item.minecraft.leather_leggings": "Learen broek",
  "item.minecraft.light_blue_bundle": "Light Blue Bundle",
  "item.minecraft.light_blue_dye": "Ljochtblauwe kleurstof",
  "item.minecraft.light_blue_harness": "Light Blue Harness",
  "item.minecraft.light_gray_bundle": "Light Gray Bundle",
  "item.minecraft.light_gray_dye": "Ljochtgrize kleurstof",
  "item.minecraft.light_gray_harness": "Light Gray Harness",
  "item.minecraft.lime_bundle": "Lime Bundle",
  "item.minecraft.lime_dye": "Ljochtgriene kleurstof",
  "item.minecraft.lime_harness": "Lime Harness",
  "item.minecraft.lingering_potion": "Brijich oanhâldende drank",
  "item.minecraft.lingering_potion.effect.awkward": "Nuvere oanhâldende drank",
  "item.minecraft.lingering_potion.effect.empty": "Net te meitsjen oanhâldende drank",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Oanhâldende drank fan fjoerwjerstân",
  "item.minecraft.lingering_potion.effect.harming": "Oanhâldende drank fan ferwûning",
  "item.minecraft.lingering_potion.effect.healing": "Oanhâldende drank fan genêzing",
  "item.minecraft.lingering_potion.effect.infested": "Lingering Potion of Infestation",
  "item.minecraft.lingering_potion.effect.invisibility": "Oanhâldende drank fan ûnsichtberens",
  "item.minecraft.lingering_potion.effect.leaping": "Oanhâldende drank fan ljeppen",
  "item.minecraft.lingering_potion.effect.levitation": "Oanhâldende drank fan sweving",
  "item.minecraft.lingering_potion.effect.luck": "Oanhâldende drank fan gelok",
  "item.minecraft.lingering_potion.effect.mundane": "Sljochte oanhâldende drank",
  "item.minecraft.lingering_potion.effect.night_vision": "Oanhâldende drank fan nachtsicht",
  "item.minecraft.lingering_potion.effect.oozing": "Lingering Potion of Oozing",
  "item.minecraft.lingering_potion.effect.poison": "Oanhâldende drank fan fergif",
  "item.minecraft.lingering_potion.effect.regeneration": "Oanhâldende drank fan regeneraasje",
  "item.minecraft.lingering_potion.effect.slow_falling": "Oanhâldende drank der falfertraging",
  "item.minecraft.lingering_potion.effect.slowness": "Oanhâldende drank fan tragens",
  "item.minecraft.lingering_potion.effect.strength": "Oanhâldende drank fan krêft",
  "item.minecraft.lingering_potion.effect.swiftness": "Oanhâldende drank fan fluggens",
  "item.minecraft.lingering_potion.effect.thick": "Brijige oanhâldende drank",
  "item.minecraft.lingering_potion.effect.turtle_master": "Oanhâldende drank der skyldpodmaster",
  "item.minecraft.lingering_potion.effect.water": "Oanhâldende wetterflesse",
  "item.minecraft.lingering_potion.effect.water_breathing": "Oanhâldende drank fan ûnder wetter sykhelje",
  "item.minecraft.lingering_potion.effect.weakness": "Oanhâldende drank fan swakkens",
  "item.minecraft.lingering_potion.effect.weaving": "Lingering Potion of Weaving",
  "item.minecraft.lingering_potion.effect.wind_charged": "Lingering Potion of Wind Charging",
  "item.minecraft.llama_spawn_egg": "Lamaspawnaai",
  "item.minecraft.lodestone_compass": "Kompas wizend nei seilstien",
  "item.minecraft.mace": "Knodze",
  "item.minecraft.magenta_bundle": "Magenta Bundle",
  "item.minecraft.magenta_dye": "Maginta kleurstof",
  "item.minecraft.magenta_harness": "Magenta Harness",
  "item.minecraft.magma_cream": "Magmakrême",
  "item.minecraft.magma_cube_spawn_egg": "Magmakubusspawnaai",
  "item.minecraft.mangrove_boat": "Mangrovehouten boat",
  "item.minecraft.mangrove_chest_boat": "Mangrovehouten boat mei kiste",
  "item.minecraft.map": "Lege kaart",
  "item.minecraft.melon_seeds": "Wettermeloensieden",
  "item.minecraft.melon_slice": "Meloenskiif",
  "item.minecraft.milk_bucket": "Amer milk",
  "item.minecraft.minecart": "Mynkarre",
  "item.minecraft.miner_pottery_shard": "Ierdewurkskerf ‘mynwurker’",
  "item.minecraft.miner_pottery_sherd": "Ierdewurk diggel mynwurker",
  "item.minecraft.mojang_banner_pattern": "Banierpatroan",
  "item.minecraft.mojang_banner_pattern.desc": "Mojangwapen",
  "item.minecraft.mojang_banner_pattern.new": "Thing Banner Pattern",
  "item.minecraft.mooshroom_spawn_egg": "Mooshroomspawnaai",
  "item.minecraft.mourner_pottery_shard": "Ierdewurkskerf ‘rou’",
  "item.minecraft.mourner_pottery_sherd": "Ierdewurk diggel rou",
  "item.minecraft.mule_spawn_egg": "Mûlezelspawnaai",
  "item.minecraft.mushroom_stew": "Poddestuollensnuorrepot",
  "item.minecraft.music_disc_11": "Muzykplaat",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Muzykplaat",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Muzykplaat",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Muzykplaat",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Muzykplaat",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Muzykplaat",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Muzykplaat",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Muzykplaat",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Muzykdoaze)",
  "item.minecraft.music_disc_far": "Muzykplaat",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Muzykplaat",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Muzykplaat",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Muzykplaat",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Muzykplaat",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Muzykplaat",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Muzykplaat",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Muzykplaat",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Muzykplaat",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Muzykplaat",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Muzykplaat",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Muzykplaat",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Muzykplaat",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Rau skieppefleis",
  "item.minecraft.name_tag": "Nammelabel",
  "item.minecraft.nautilus_shell": "Nautilusskelp",
  "item.minecraft.nautilus_spawn_egg": "Nautilusspawnaai",
  "item.minecraft.nether_brick": "Nether-bakstiennen",
  "item.minecraft.nether_star": "Nether-stjer",
  "item.minecraft.nether_wart": "Netherkrûd",
  "item.minecraft.netherite_axe": "Netheryt-bile",
  "item.minecraft.netherite_boots": "Netheryt-skuon",
  "item.minecraft.netherite_chestplate": "Netheryt-boarstplaat",
  "item.minecraft.netherite_helmet": "Netheryt-helm",
  "item.minecraft.netherite_hoe": "Netheryt-skoffel",
  "item.minecraft.netherite_horse_armor": "Netherite Horse Armor",
  "item.minecraft.netherite_ingot": "Netheryt-staaf",
  "item.minecraft.netherite_leggings": "Netheryt-bienstikken",
  "item.minecraft.netherite_nautilus_armor": "Netherite Nautilus Armor",
  "item.minecraft.netherite_pickaxe": "Netheryt-pikhouweel",
  "item.minecraft.netherite_scrap": "Netheryt-skroat",
  "item.minecraft.netherite_shovel": "Netheryt-skeppe",
  "item.minecraft.netherite_spear": "Netheryt-spear",
  "item.minecraft.netherite_sword": "Netheryt-swurd",
  "item.minecraft.netherite_upgrade_smithing_template": "Smeisjabloan",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherite Upgrade",
  "item.minecraft.oak_boat": "Ikehouten boat",
  "item.minecraft.oak_chest_boat": "Ikehouten boat mei kiste",
  "item.minecraft.ocelot_spawn_egg": "Ocelottespawnaai",
  "item.minecraft.ominous_bottle": "Ominous Bottle",
  "item.minecraft.ominous_trial_key": "Ominous Trial Key",
  "item.minecraft.orange_bundle": "Orange Bundle",
  "item.minecraft.orange_dye": "Oranje kleurstof",
  "item.minecraft.orange_harness": "Orange Harness",
  "item.minecraft.painting": "Skilderij",
  "item.minecraft.pale_oak_boat": "Pale Oak Boat",
  "item.minecraft.pale_oak_chest_boat": "Pale Oak Boat with Chest",
  "item.minecraft.panda_spawn_egg": "Pandaspawnaai",
  "item.minecraft.paper": "Papier",
  "item.minecraft.parched_spawn_egg": "Parched Spawn Egg",
  "item.minecraft.parrot_spawn_egg": "Pappegaaiespawnaai",
  "item.minecraft.phantom_membrane": "Fantoommembraan",
  "item.minecraft.phantom_spawn_egg": "Fantomespawnaai",
  "item.minecraft.pig_spawn_egg": "Bargespawnaai",
  "item.minecraft.piglin_banner_pattern": "Banierpatroan",
  "item.minecraft.piglin_banner_pattern.desc": "Snút",
  "item.minecraft.piglin_banner_pattern.new": "Snout Banner Pattern",
  "item.minecraft.piglin_brute_spawn_egg": "Piglinbrútspawnaai",
  "item.minecraft.piglin_spawn_egg": "Piglinspawnaai",
  "item.minecraft.pillager_spawn_egg": "Rôverspawnaai",
  "item.minecraft.pink_bundle": "Pink Bundle",
  "item.minecraft.pink_dye": "Rôze kleurstof",
  "item.minecraft.pink_harness": "Pink Harness",
  "item.minecraft.pitcher_plant": "Bekerplant",
  "item.minecraft.pitcher_pod": "Bekerplantbeker",
  "item.minecraft.plenty_pottery_shard": "Ierdewurkskerf ‘oerfloed’",
  "item.minecraft.plenty_pottery_sherd": "Ierdewurk diggel oerfloed",
  "item.minecraft.poisonous_potato": "Fergiftige ierappel",
  "item.minecraft.polar_bear_spawn_egg": "Iisbearespawnaai",
  "item.minecraft.popped_chorus_fruit": "Pofte koarfrucht",
  "item.minecraft.porkchop": "Rau bargefleis",
  "item.minecraft.potato": "Ierappel",
  "item.minecraft.potion": "Drank",
  "item.minecraft.potion.effect.awkward": "Nuvere drank",
  "item.minecraft.potion.effect.empty": "Net te meitsjen drank",
  "item.minecraft.potion.effect.fire_resistance": "Drank fan fjoerwjerstân",
  "item.minecraft.potion.effect.harming": "Drank fan ferwûning",
  "item.minecraft.potion.effect.healing": "Drank fan genêzing",
  "item.minecraft.potion.effect.infested": "Potion of Infestation",
  "item.minecraft.potion.effect.invisibility": "Drank fan ûnsichtberens",
  "item.minecraft.potion.effect.leaping": "Drank fan ljeppen",
  "item.minecraft.potion.effect.levitation": "Drank fan sweving",
  "item.minecraft.potion.effect.luck": "Drank fan gelok",
  "item.minecraft.potion.effect.mundane": "Sljochte drank",
  "item.minecraft.potion.effect.night_vision": "Drank fan nachtsicht",
  "item.minecraft.potion.effect.oozing": "Potion of Oozing",
  "item.minecraft.potion.effect.poison": "Drank fan fergif",
  "item.minecraft.potion.effect.regeneration": "Drank fan regeneraasje",
  "item.minecraft.potion.effect.slow_falling": "Drank der falfertraging",
  "item.minecraft.potion.effect.slowness": "Drank fan tragens",
  "item.minecraft.potion.effect.strength": "Drank fan krêft",
  "item.minecraft.potion.effect.swiftness": "Drank fan fluggens",
  "item.minecraft.potion.effect.thick": "Brijige drank",
  "item.minecraft.potion.effect.turtle_master": "Drank der skyldpodmaster",
  "item.minecraft.potion.effect.water": "Wetterflesse",
  "item.minecraft.potion.effect.water_breathing": "Drank fan ûnder wetter sykhelje",
  "item.minecraft.potion.effect.weakness": "Drank fan swakkens",
  "item.minecraft.potion.effect.weaving": "Potion of Weaving",
  "item.minecraft.potion.effect.wind_charged": "Potion of Wind Charging",
  "item.minecraft.pottery_shard_archer": "Ierdewurkskerf ‘bôgeskutter’",
  "item.minecraft.pottery_shard_arms_up": "Ierdewurkskerf ‘earms omheech’",
  "item.minecraft.pottery_shard_prize": "Ierdewurkskerf ‘beleaning’",
  "item.minecraft.pottery_shard_skull": "Ierdewurkskerf ‘deadskop’",
  "item.minecraft.powder_snow_bucket": "Amer poeiersnie",
  "item.minecraft.prismarine_crystals": "Prismarinekristallen",
  "item.minecraft.prismarine_shard": "Prismarineskerf",
  "item.minecraft.prize_pottery_shard": "Ierdewurkskerf ‘priis’",
  "item.minecraft.prize_pottery_sherd": "Ierdewurk diggel priis",
  "item.minecraft.pufferfish": "Kûgelfisk",
  "item.minecraft.pufferfish_bucket": "Amer kûgelfisk",
  "item.minecraft.pufferfish_spawn_egg": "Kûgelfiskespawnaai",
  "item.minecraft.pumpkin_pie": "Pompoentaart",
  "item.minecraft.pumpkin_seeds": "Pompoensieden",
  "item.minecraft.purple_bundle": "Purple Bundle",
  "item.minecraft.purple_dye": "Pearze kleurstof",
  "item.minecraft.purple_harness": "Purple Harness",
  "item.minecraft.quartz": "Nether-kwarts",
  "item.minecraft.rabbit": "Rau kninefleis",
  "item.minecraft.rabbit_foot": "Kninepoatsje",
  "item.minecraft.rabbit_hide": "Kninefel",
  "item.minecraft.rabbit_spawn_egg": "Kninespawnaai",
  "item.minecraft.rabbit_stew": "Kninesnuorrepot",
  "item.minecraft.raiser_armor_trim_smithing_template": "Smeisjabloan",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Raiser Armor Trim",
  "item.minecraft.ravager_spawn_egg": "Ferwoasterspawnaai",
  "item.minecraft.raw_copper": "Rûch koper",
  "item.minecraft.raw_gold": "Rûch goud",
  "item.minecraft.raw_iron": "Rûch izer",
  "item.minecraft.recovery_compass": "Werstelkompas",
  "item.minecraft.red_bundle": "Red Bundle",
  "item.minecraft.red_dye": "Reade kleurstof",
  "item.minecraft.red_harness": "Red Harness",
  "item.minecraft.redstone": "Redstonestof",
  "item.minecraft.resin_brick": "Resin Brick",
  "item.minecraft.resin_clump": "Resin Clump",
  "item.minecraft.rib_armor_trim_smithing_template": "Smeisjabloan",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rib Armor Trim",
  "item.minecraft.rotten_flesh": "Bedoarn fleis",
  "item.minecraft.saddle": "Seal",
  "item.minecraft.salmon": "Rauwe salm",
  "item.minecraft.salmon_bucket": "Amer salm",
  "item.minecraft.salmon_spawn_egg": "Salmspawnaai",
  "item.minecraft.scrape_pottery_sherd": "Scrape Pottery Sherd",
  "item.minecraft.scute": "Skyld",
  "item.minecraft.sentry_armor_trim_smithing_template": "Smeisjabloan",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Sentry Armor Trim",
  "item.minecraft.shaper_armor_trim_smithing_template": "Smeisjabloan",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Shaper Armor Trim",
  "item.minecraft.sheaf_pottery_shard": "Ierdewurkskerf ‘skeaf’",
  "item.minecraft.sheaf_pottery_sherd": "Ierdewurk diggel skeaf",
  "item.minecraft.shears": "Skjirre",
  "item.minecraft.sheep_spawn_egg": "Skiepespawnaai",
  "item.minecraft.shelter_pottery_shard": "Ierdewurkskerf ‘skûlplak’",
  "item.minecraft.shelter_pottery_sherd": "Ierdewurk diggel skûlplak",
  "item.minecraft.shield": "Skyld",
  "item.minecraft.shield.black": "Swart skyld",
  "item.minecraft.shield.blue": "Blau skyld",
  "item.minecraft.shield.brown": "Brún skyld",
  "item.minecraft.shield.cyan": "Turkoaiske skyld",
  "item.minecraft.shield.gray": "Griis skyld",
  "item.minecraft.shield.green": "Grien skyld",
  "item.minecraft.shield.light_blue": "Ljochtblau skyld",
  "item.minecraft.shield.light_gray": "Ljochtgriis skyld",
  "item.minecraft.shield.lime": "Ljochtgrien skyld",
  "item.minecraft.shield.magenta": "Maginta skyld",
  "item.minecraft.shield.orange": "Oranje skyld",
  "item.minecraft.shield.pink": "Rôze skyld",
  "item.minecraft.shield.purple": "Pears skyld",
  "item.minecraft.shield.red": "Read skyld",
  "item.minecraft.shield.white": "Wyt skyld",
  "item.minecraft.shield.yellow": "Giel skyld",
  "item.minecraft.shulker_shell": "Shulker-skelp",
  "item.minecraft.shulker_spawn_egg": "Shulkerspawnaai",
  "item.minecraft.sign": "Boerd",
  "item.minecraft.silence_armor_trim_smithing_template": "Smeisjabloan",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Silence Armor Trim",
  "item.minecraft.silverfish_spawn_egg": "Silverfiskespawnaai",
  "item.minecraft.skeleton_horse_spawn_egg": "Skelettehynderspawnaai",
  "item.minecraft.skeleton_spawn_egg": "Skelettespawnaai",
  "item.minecraft.skull_banner_pattern": "Banierpatroan",
  "item.minecraft.skull_banner_pattern.desc": "Deadskopwapen",
  "item.minecraft.skull_banner_pattern.new": "Skull Charge Banner Pattern",
  "item.minecraft.skull_pottery_shard": "Ierdewurkskerf ‘deadskop’",
  "item.minecraft.skull_pottery_sherd": "Ierdewurk diggel deadskop",
  "item.minecraft.slime_ball": "Slymbal",
  "item.minecraft.slime_spawn_egg": "Slymkubusspawnaai",
  "item.minecraft.smithing_template": "Smeisjabloan",
  "item.minecraft.smithing_template.applies_to": "Fan tapassing op:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Staf of kristal tafoegje",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Wapenrêsting",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Harnasstik tafoegje",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Staven en kristallen",
  "item.minecraft.smithing_template.ingredients": "Yngrediïnten:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Netheryt-stêf tafoegje",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamanten útris",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Diamanten harnas, wapen of ark tafoegje",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netheryt-stêf",
  "item.minecraft.smithing_template.upgrade": "Fernije: ",
  "item.minecraft.sniffer_spawn_egg": "Sneuperspawnaai",
  "item.minecraft.snort_pottery_shard": "Ierdewurkskerf ‘sneupje’",
  "item.minecraft.snort_pottery_sherd": "Ierdewurk diggel sneupje",
  "item.minecraft.snout_armor_trim_smithing_template": "Smeisjabloan",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Snout Armor Trim",
  "item.minecraft.snow_golem_spawn_egg": "Sniegolemspawnaai",
  "item.minecraft.snowball": "Sniebal",
  "item.minecraft.spectral_arrow": "Spektrale pylk",
  "item.minecraft.spider_eye": "Spinne-each",
  "item.minecraft.spider_spawn_egg": "Spinnespawnaai",
  "item.minecraft.spire_armor_trim_smithing_template": "Smeisjabloan",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Spire Armor Trim",
  "item.minecraft.splash_potion": "Splash Potion",
  "item.minecraft.splash_potion.effect.awkward": "Nuvere spattende drank",
  "item.minecraft.splash_potion.effect.empty": "Net te meitsjen spattende drank",
  "item.minecraft.splash_potion.effect.fire_resistance": "Spattende drank fan fjoerwjerstân",
  "item.minecraft.splash_potion.effect.harming": "Spattende drank fan ferwûning",
  "item.minecraft.splash_potion.effect.healing": "Spattende drank fan genêzing",
  "item.minecraft.splash_potion.effect.infested": "Splash Potion of Infestation",
  "item.minecraft.splash_potion.effect.invisibility": "Spattende drank fan ûnsichtberens",
  "item.minecraft.splash_potion.effect.leaping": "Spattende drank fan ljeppen",
  "item.minecraft.splash_potion.effect.levitation": "Spattende drank fan sweving",
  "item.minecraft.splash_potion.effect.luck": "Spattende drank fan gelok",
  "item.minecraft.splash_potion.effect.mundane": "Sljochte spattende drank",
  "item.minecraft.splash_potion.effect.night_vision": "Spattende drank fan nachtsicht",
  "item.minecraft.splash_potion.effect.oozing": "Splash Potion of Oozing",
  "item.minecraft.splash_potion.effect.poison": "Spattende drank fan fergif",
  "item.minecraft.splash_potion.effect.regeneration": "Spattende drank fan regeneraasje",
  "item.minecraft.splash_potion.effect.slow_falling": "Spattende drank der falfertraging",
  "item.minecraft.splash_potion.effect.slowness": "Spattende drank fan tragens",
  "item.minecraft.splash_potion.effect.strength": "Spattende drank fan krêft",
  "item.minecraft.splash_potion.effect.swiftness": "Spattende drank fan fluggens",
  "item.minecraft.splash_potion.effect.thick": "Brijige spattende drank",
  "item.minecraft.splash_potion.effect.turtle_master": "Spattende drank der skyldpodmaster",
  "item.minecraft.splash_potion.effect.water": "Spattende weterflesse",
  "item.minecraft.splash_potion.effect.water_breathing": "Spattende drank fan ûnder wetter sykhelje",
  "item.minecraft.splash_potion.effect.weakness": "Spattende drank fan swakkens",
  "item.minecraft.splash_potion.effect.weaving": "Splash Potion of Weaving",
  "item.minecraft.splash_potion.effect.wind_charged": "Splash Potion of Wind Charging",
  "item.minecraft.spruce_boat": "Spjirrehouten boat",
  "item.minecraft.spruce_chest_boat": "Sparrehouten boat mei kiste",
  "item.minecraft.spyglass": "Ferrekijker",
  "item.minecraft.squid_spawn_egg": "Inketfiskespawnaai",
  "item.minecraft.stick": "Stôk",
  "item.minecraft.stone_axe": "Stiennen bile",
  "item.minecraft.stone_hoe": "Stiennen skoffel",
  "item.minecraft.stone_pickaxe": "Stiennen houwiel",
  "item.minecraft.stone_shovel": "Stiennen skeppe",
  "item.minecraft.stone_spear": "Stiennen spear",
  "item.minecraft.stone_sword": "Stiennen swurd",
  "item.minecraft.stray_spawn_egg": "Swalkerspawnaai",
  "item.minecraft.strider_spawn_egg": "Lavariderspawnaai",
  "item.minecraft.string": "Tried",
  "item.minecraft.sugar": "Sûker",
  "item.minecraft.suspicious_stew": "Geheimsinnige stoofpot",
  "item.minecraft.sweet_berries": "Swietbessen",
  "item.minecraft.tadpole_bucket": "Amer kikkertfisk",
  "item.minecraft.tadpole_spawn_egg": "Kikkertfiskspawnaai",
  "item.minecraft.tide_armor_trim_smithing_template": "Smeisjabloan",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Tide Armor Trim",
  "item.minecraft.tipped_arrow": "Dipte pylk",
  "item.minecraft.tipped_arrow.effect.awkward": "Dipte pylk",
  "item.minecraft.tipped_arrow.effect.empty": "Net te meitsjen tipte pylk",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Pylk fan fjoerwjerstân",
  "item.minecraft.tipped_arrow.effect.harming": "Pylk fan ferwûning",
  "item.minecraft.tipped_arrow.effect.healing": "Pylk fan genêzing",
  "item.minecraft.tipped_arrow.effect.infested": "Arrow of Infestation",
  "item.minecraft.tipped_arrow.effect.invisibility": "Pylk fan ûnsichtberens",
  "item.minecraft.tipped_arrow.effect.leaping": "Pylk fan ljeppen",
  "item.minecraft.tipped_arrow.effect.levitation": "Pylk fan sweving",
  "item.minecraft.tipped_arrow.effect.luck": "Pylk fan gelok",
  "item.minecraft.tipped_arrow.effect.mundane": "Dipte pylk",
  "item.minecraft.tipped_arrow.effect.night_vision": "Pylk fan nachtsicht",
  "item.minecraft.tipped_arrow.effect.oozing": "Arrow of Oozing",
  "item.minecraft.tipped_arrow.effect.poison": "Pylk fan fergif",
  "item.minecraft.tipped_arrow.effect.regeneration": "Pylk fan regeneraasje",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Pylk der falfertraging",
  "item.minecraft.tipped_arrow.effect.slowness": "Pylk fan tragens",
  "item.minecraft.tipped_arrow.effect.strength": "Pylk fan krêft",
  "item.minecraft.tipped_arrow.effect.swiftness": "Pylk fan fluggens",
  "item.minecraft.tipped_arrow.effect.thick": "Dipte pylk",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Pylk der skyldpodmaster",
  "item.minecraft.tipped_arrow.effect.water": "Pylk fan spatting",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Pylk fan ûnder wetter sykhelje",
  "item.minecraft.tipped_arrow.effect.weakness": "Pylk fan swakkens",
  "item.minecraft.tipped_arrow.effect.weaving": "Arrow of Weaving",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Arrow of Wind Charging",
  "item.minecraft.tnt_minecart": "Mynkarre mei TNT",
  "item.minecraft.torchflower_seeds": "Fakkelblomsiedsjes",
  "item.minecraft.totem_of_undying": "Toatem fan ûnstjerlikheid",
  "item.minecraft.trader_llama_spawn_egg": "Hannelerslamaspawnaai",
  "item.minecraft.trial_key": "Trial Key",
  "item.minecraft.trident": "Trijetyn",
  "item.minecraft.tropical_fish": "Tropyske fisk",
  "item.minecraft.tropical_fish_bucket": "Amer tropyske fisk",
  "item.minecraft.tropical_fish_spawn_egg": "Tropyskefiskenspawnaai",
  "item.minecraft.turtle_helmet": "Skyldpodskyld",
  "item.minecraft.turtle_scute": "Turtle Scute",
  "item.minecraft.turtle_spawn_egg": "Skyldpoddenspawnaai",
  "item.minecraft.vex_armor_trim_smithing_template": "Smeisjabloan",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Vex Armor Trim",
  "item.minecraft.vex_spawn_egg": "Ergernissenspawnaai",
  "item.minecraft.villager_spawn_egg": "Doarpelingenspawnaai",
  "item.minecraft.vindicator_spawn_egg": "Ferdigenerspawnaai",
  "item.minecraft.wandering_trader_spawn_egg": "Rûnreizigjendehannelersspawnaai",
  "item.minecraft.ward_armor_trim_smithing_template": "Smeisjabloan",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ward Armor Trim",
  "item.minecraft.warden_spawn_egg": "Hoederspawnaai",
  "item.minecraft.warped_fungus_on_a_stick": "Spûkeftige swam oan in stûk",
  "item.minecraft.water_bucket": "Amer wetter",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Smeisjabloan",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Wayfinder Armor Trim",
  "item.minecraft.wheat": "Weet",
  "item.minecraft.wheat_seeds": "Weetsied",
  "item.minecraft.white_bundle": "White Bundle",
  "item.minecraft.white_dye": "Wite kleurstof",
  "item.minecraft.white_harness": "White Harness",
  "item.minecraft.wild_armor_trim_smithing_template": "Smeisjabloan",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Wild Armor Trim",
  "item.minecraft.wind_charge": "Wind Charge",
  "item.minecraft.witch_spawn_egg": "Heksespawnaai",
  "item.minecraft.wither_skeleton_spawn_egg": "Witherskelettenspawnaai",
  "item.minecraft.wither_spawn_egg": "Witherspawnaai",
  "item.minecraft.wolf_armor": "Wolf Armor",
  "item.minecraft.wolf_spawn_egg": "Wolvenspawnaai",
  "item.minecraft.wooden_axe": "Houten bile",
  "item.minecraft.wooden_hoe": "Houten skoffel",
  "item.minecraft.wooden_pickaxe": "Houten houwiel",
  "item.minecraft.wooden_shovel": "Houten skeppe",
  "item.minecraft.wooden_spear": "Houten spear",
  "item.minecraft.wooden_sword": "Houten swurd",
  "item.minecraft.writable_book": "Boek en guozzefear",
  "item.minecraft.written_book": "Skreaune boek",
  "item.minecraft.yellow_bundle": "Yellow Bundle",
  "item.minecraft.yellow_dye": "Giele kleurstof",
  "item.minecraft.yellow_harness": "Yellow Harness",
  "item.minecraft.zoglin_spawn_egg": "Zoglinspawnaai",
  "item.minecraft.zombie_horse_spawn_egg": "Sombyhynstespawnaai",
  "item.minecraft.zombie_nautilus_spawn_egg": "Sombynautilusspawnaai",
  "item.minecraft.zombie_spawn_egg": "Sombyspawnaai",
  "item.minecraft.zombie_villager_spawn_egg": "Sombydoarpelingenspawnaai",
  "item.minecraft.zombified_piglin_spawn_egg": "Sombypiglinspawnaai"
}
export const fy_nl = items; 
